<template>
    <div>
        <div v-if="cargando">
            <b-row cols="12" sm="6"	md="4" lg="4" xl="12">
                <b-col class="text-center">
                       <h2>Cargando <i class="fa fa-spin fa-spinner"></i></h2> 
                </b-col>
            </b-row>
        </div>
        <div v-else>
        <b-card v-if="!ocultarGuiaTransportista">
            <div slot="header">
                <b-row>
                    <b-col>
                        <h3 class="text-center">Guía de Remision Trasportista Electrónica</h3>
                    </b-col>
                </b-row>
                <b-row>
                    <!-- <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                        <div style="background-color:red">
                            Fecha Emisión:
                        </div>
                    </b-col> -->
                    <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2">
                        <b-badge>Fecha Emisión:</b-badge>
                        <datepicker 
                            v-model="femision" 
                            :format="customFormatterEmisionGRT" 
                            :language="es" 
                            :bootstrap-styling="true" 
                            :disabledDates="diasnopermitidos" 
                            :placeholder="currentdate">
                        </datepicker>
                    </b-col>
                </b-row>
            </div>
            <div>
                <!-- Datos Remitente -->
                <b-card style="border: #00b3b3 3px solid;">
                 <h5><p class="titulosPrimario">Datos Remitente</p></h5>
                 <b-row>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="1">
                        <b-select class="bordesYtexto input-buscar" v-model="tipoDocumentoRemitente">
                            <option 
                                :value="tipoDocumento.tipo" 
                                v-for="tipoDocumento in documentoIdentidadGuia" 
                                v-bind:key="tipoDocumento.tipo">
                                {{tipoDocumento.nombre}}
                            </option>
                        </b-select>
                    </b-col>
                    <!-- Buscar por documento -->
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-form-input
                            class="bordesYtexto input-buscar"
                            placeholder="Buscar..."
                            type="number"
                            v-model="remitente.numero"
                            @change="pitcherReceiverRemitente(1)">
                        </b-form-input>
                        <b-list-group v-if="listaRemitente" class="searcher-field">
                            <b-list-group-item 
                                v-for="(item, index) in listaRemitentes"
                                :key="index" @click="setReceiverRemitente(item)" 
                                class="searcher-result">
                                {{item.idReceptor + ' - ' + item.razonSocial}}
                            </b-list-group-item>
                        </b-list-group>
                        <div v-if="buscandoRemitente">                                
                            <template >
                                Buscando... <i class="fa fa-spin fa-spinner"></i>
                            </template> 
                        </div>
                        <b-list-group v-if="mostrardniRemitente" class="searcher-field">                                
                            <template >
                                <b-list-group-item  @click="setReceiverdniRemitente(listadni)" class="searcher-result">{{listadni.nombre + ' -- ' + listadni.dni}}</b-list-group-item>
                            </template> 
                        </b-list-group> 
                    </b-col>
                    <!-- Razon Social -->
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                        <b-form-input 
                            class="bordesYtexto input-buscar"
                            placeholder="Razón Social"
                            type="text"
                            v-model="remitente.razonSocial">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                        <b-input-group>
                            <b-form-input
                            class="bordesYtexto input-buscar"
                                placeholder="Dirección"
                                type="text"
                                v-model="remitente.direccion">
                            </b-form-input>
                            <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                                <b-button 
                                variant="primary"
                                class="pb-0 pt-0 pl-1 pr-1"
                                size="sm"
                                @click="changeDirectionRemitente()">
                                    <i class="fa fa-list "></i>
                                </b-button>
                            </b-input-group-text>
                        </b-input-group>
                        <!-- Lista de direcciones opcionales -->
                        <template v-if="verDireccionesRemitente">
                            <b-list-group-item 
                                v-for="(item, index) in direcciones" 
                                :key="index"
                                @click="setDirectionRemitente(item)"
                                class="searcher-result">
                                {{item.direccion}}
                            </b-list-group-item>
                        </template>
                    </b-col>
                     <!-- Series -->
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="1">
                        <b-select class="bordesYtexto input-buscar" v-model="serieInicial">
                            <option 
                                v-for="(serie, index) in listaSeries" 
                                :value="index" 
                                :key="index">
                                {{serie}}
                            </option>
                        </b-select>
                    </b-col>
                 </b-row>
                 <br>
                  <!-- Datos receptor -->
                <h5><p class="titulosPrimario">Datos Destinatario</p></h5>
                <b-row>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="1">
                        <b-select class="bordesYtexto input-buscar" v-model="tipoDocumento">
                            <option 
                                :value="tipodocumento.tipo" 
                                v-for="tipodocumento in documentoIdentidadGuia" 
                                v-bind:key="tipodocumento.tipo">
                                {{tipodocumento.nombre}}
                            </option>
                        </b-select>
                    </b-col>
                    <!-- Buscar por documento -->
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-form-input
                            class="bordesYtexto input-buscar"
                            placeholder="Buscar..."
                            type="number"
                            v-model="receptor.numero"
                            @change="pitcherReceiver(1)">
                        </b-form-input>
                        <b-list-group v-if="listaReceptor" class="searcher-field">
                            <b-list-group-item 
                                v-for="(item, index) in listaReceptores"
                                :key="index" @click="setReceiver(item)" 
                                class="searcher-result">
                                {{item.idReceptor + ' - ' + item.razonSocial}}
                            </b-list-group-item>
                        </b-list-group>
                        <div v-if="buscandoReceptor">                                
                            <template >
                                Buscando... <i class="fa fa-spin fa-spinner"></i>
                            </template> 
                        </div>
                        <b-list-group v-if="mostrardniReceptor" class="searcher-field">                                
                            <template >
                                <b-list-group-item  @click="setReceiverdniReceptor(listadni)" class="searcher-result">{{listadni.nombre + ' -- ' + listadni.dni}}</b-list-group-item>
                            </template> 
                        </b-list-group> 
                    </b-col>
                    <!-- Razon Social -->
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                        <b-form-input 
                            class="bordesYtexto input-buscar"
                            placeholder="Razón Social"
                            type="text"
                            v-model="receptor.razonSocial">
                        </b-form-input>
                    </b-col>
                    <!-- Direccion -->
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                        <b-input-group>
                            <b-form-input
                                class="bordesYtexto input-buscar"
                                placeholder="Dirección"
                                type="text"
                                v-model="receptor.direccion">
                            </b-form-input>
                            <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                                <b-button 
                                variant="primary"
                                class="pb-0 pt-0 pl-1 pr-1"
                                size="sm"
                                @click="changeDirection()">
                                    <i class="fa fa-list "></i>
                                </b-button>
                            </b-input-group-text>
                        </b-input-group>
                        <!-- Lista de direcciones opcionales -->
                        <template v-if="verDirecciones">
                            <b-list-group-item 
                                v-for="(item, index) in direcciones" 
                                :key="index"
                                @click="setDirection(item)"
                                class="searcher-result">
                                {{item.direccion}}
                            </b-list-group-item>
                        </template>
                    </b-col>
                </b-row>
                 <br>
                <!-- Datos de ubicacion -->
               <h5><p class="titulosPrimario">Datos de la Ubicación <i class="fa fa-tack fa-lg"></i></p>
               
               </h5>
                <b-row>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-input-group>
                            <b-form-input
                                class="bordesYtexto input-buscar"
                                placeholder="Ubigeo Partida"
                                type="number"
                                v-model="ubigeoPartida">
                            </b-form-input>
                            <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                                <b-button
                                    variant="primary"
                                    size="sm"
                                    class="pb-0 pt-0 pl-1 pr-1" 
                                    @click="modalUbigeoPartida = true">
                                    <i class="fas fa-search"></i>
                                </b-button>
                            </b-input-group-text>
                        </b-input-group>  
                    <!-- Modal ubigeo partida -->
                    <b-modal v-model="modalUbigeoPartida" title="Ubigeo de Partida" size="lg">
                    <b-row>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                            <template>
                                <h5> Selecciona Departamento </h5>
                                <select 
                                    class="custom-select mr-sm-2" 
                                    v-model="departamentoSeleccionadoUbigeoOrigen">
                                    <option 
                                        v-for="departamento in listDepartamento" 
                                        :value="departamento.codDepartamento" 
                                        :key="departamento.codDepartamento">
                                        {{ departamento.nombre }}
                                    </option>
                                </select>
                            </template>
                        </b-col>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                            <template>
                                <h5> Selecciona Provincia </h5>
                                <div v-if="!provOrigen">
                                    <b-form-input 
                                        type="text"
                                        disabled>
                                    </b-form-input>
                                </div>
                                <div v-else-if="provOrigenCargando">
                                    Cargando 
                                    <i class="fa fa-spin fa-spinner"></i>
                                </div>
                                <div v-else>
                                    <select 
                                        class="custom-select mr-sm-2" 
                                        v-model="provinciaSeleccionadaUbigeoOrigen">
                                        <option 
                                            v-for="provincia in listProvinceOrigen" 
                                            :value="provincia.codProvincia" 
                                            :key="provincia.codProvincia">
                                            {{ provincia.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </template>
                        </b-col>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                             <template>
                                <h5> Selecciona Distrito </h5>
                                <div v-if="!distOrigen">
                                    <b-form-input 
                                        type="text"
                                        disabled
                                        placeholder="Selecciona una Provincia...">
                                    </b-form-input>
                                </div>
                                <div v-else-if="distOrigenCargando">
                                   Cargando 
                                   <i class="fa fa-spin fa-spinner"></i>
                                </div>
                                <div v-else>
                                    <select 
                                        class="custom-select mr-sm-2" 
                                        v-model="distritoSeleccionadoUbigeoOrigen">
                                        <option 
                                            v-for="distrito in listDistrictOrigen" 
                                            :value="distrito.codDistrito"
                                            :key="distrito.codDistrito">
                                            {{ distrito.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </template>
                        </b-col>
                    </b-row>
                    </b-modal>
                    </b-col>
                    <!-- Direccion partida  -->
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                        <template v-if="mostrarubigeoTexto" >
                            <b-input-group>
                            <b-form-input
                                class="bordesYtexto input-buscar"
                                placeholder="Dirección Partida"
                                v-model="direccionPartidaTexto"
                                >
                            </b-form-input>
                            <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                                <b-button
                                    class="pb-0 pt-0 pl-1 pr-1"
                                    size="sm"
                                    variant="primary"
                                    @click="cambiarASelecctorDireccion(1)">
                                    <i class="fas fa-keyboard"></i>               
                                </b-button>
                            </b-input-group-text>
                            </b-input-group>
                        </template>
                        <template v-else>
                            <b-input-group>
                                <b-select class="bordesYtexto input-buscar" v-model="direccionPartidaSelector" >
                                    <option 
                                        v-for="(dirubigeo, index) in listUbigeo"
                                        :value="index" 
                                        :key="index" >
                                        {{dirubigeo.direccion}}
                                    </option>
                                    
                                </b-select>
                                <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                                    <b-button
                                        class="pb-0 pt-0 pl-1 pr-1"
                                        variant="primary"
                                        size="sm"
                                        @click="cambiarASelecctorDireccion(2)">
                                        <i class="fas fa-list-ol"></i>
                                    </b-button>
                                </b-input-group-text>
                            </b-input-group>
                        </template>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-input-group>
                            <b-form-input
                                class="bordesYtexto input-buscar"
                                placeholder="Ubigeo Llegada"
                                type="number"
                                v-model="ubigeoLlegada">
                            </b-form-input>
                            <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                                <b-button
                                    variant="primary"
                                    size="sm"
                                    class="pb-0 pt-0 pl-1 pr-1" 
                                    @click="modalUbigeoLlegada = true">
                                    <i class="fas fa-search"></i>
                                </b-button>
                            </b-input-group-text>
                        </b-input-group>
                        <!-- modal ubigeo Llegada -->
                    <b-modal v-model="modalUbigeoLlegada" title="Ubigeo de Llegada" size="lg">
                    <b-row>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                            <template>
                                <h5> Selecciona Departamento </h5>
                                <select
                                    class="custom-select mr-sm-2" 
                                    v-model="departamentoSeleccionadoUbigeoLlegada">
                                    <option 
                                        v-for="departamento in listDepartamentoLlegada" 
                                        :value="departamento.codDepartamento" 
                                        :key="departamento.codDepartamento">
                                        {{ departamento.nombre }}
                                    </option>
                                </select>
                            </template>
                        </b-col>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                            <template>
                                <h5> Selecciona Provincia </h5>
                                <div v-if="!provLlegada">
                                    <b-form-input 
                                        type="text"
                                        disabled>
                                    </b-form-input>
                                </div>
                                <div v-else-if="provLlegadaCargando">
                                    Cargando 
                                    <i class="fa fa-spin fa-spinner"></i>
                                </div>
                                <div v-else>
                                    <select 
                                        class="custom-select mr-sm-2" 
                                        v-model="provinciaSeleccionadaUbigeoLlegada">
                                        <option 
                                            v-for="provincia in listProvinceLlegada" 
                                            :value="provincia.codProvincia" 
                                            :key="provincia.codProvincia">
                                            {{ provincia.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </template>
                        </b-col>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                             <template>
                                <h5> Selecciona Distrito </h5>
                                <div v-if="!distLlegada">
                                    <b-form-input 
                                        type="text"
                                        disabled
                                        placeholder="Selecciona una Provincia...">
                                    </b-form-input>
                                </div>
                                <div v-else-if="distLlegadaCargando">
                                   Cargando 
                                   <i class="fa fa-spin fa-spinner"></i>
                                </div>
                                <div v-else>
                                    <select 
                                        class="custom-select mr-sm-2" 
                                        v-model="distritoSeleccionadoUbigeoLlegada">
                                        <option 
                                            v-for="distrito in listDistrictLlegada" 
                                            :value="distrito.codDistrito"
                                            :key="distrito.codDistrito">
                                            {{ distrito.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </template>
                        </b-col>
                    </b-row>
                    </b-modal>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                        <template v-if="mostrarubigeoTextoLlegada" >
                            <b-input-group>
                            <b-form-input
                                class="bordesYtexto input-buscar"
                                placeholder="Dirección Llegada"
                                v-model="direccionLlegadaTexto"
                                maxlength="100">
                            </b-form-input>
                            <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                                <b-button
                                    :disabled="validarDireccionLlegada()"
                                    class="pb-0 pt-0 pl-1 pr-1"
                                    size="sm"
                                    variant="primary"
                                    @click="cambiarASelecctorDireccionLlegada(1)">
                                    <i class="fas fa-keyboard"></i>               
                                </b-button>
                            </b-input-group-text>
                            </b-input-group>
                        </template>
                        <template v-else>
                            <b-input-group>
                                <b-select class="bordesYtexto input-buscar" v-model="direccionLlegadaSelector" >
                                    <option 
                                        v-for="(dirubigeo, index) in capturaDireccionesLlegada"
                                        :value="index" 
                                        :key="index" >
                                        {{dirubigeo.direccion}}
                                    </option>
                                </b-select>
                                <b-input-group-text slot="append">
                                    <b-button
                                        class="pb-0 pt-0 pl-1 pr-1"
                                        variant="primary"
                                        size="sm"
                                        @click="cambiarASelecctorDireccionLlegada(2)">
                                        <i class="fas fa-list-ol"></i>
                                    </b-button>
                                </b-input-group-text>
                            </b-input-group>
                        </template>
                    </b-col>
                </b-row>
                </b-card>
                <!-- Datos del Vehiculo -->
                <b-card style="border: #00b3b3 3px solid;">
                <h5><p class="titulosPrimario">Datos del Vehículo Principal <i class="fa fa-truck fa-lg" aria-hidden="true"></i></p></h5>
                <b-row>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="3">
                        <b-form-group
                            :state="stateCirculacionVehiculoPlaca"
                            :invalid-feedback="invalidFeedbackCirculacionVehiculoPlaca">                          
                        <b-input-group>
                            <b-form-input
                            class="bordesYtexto input-buscar"
                            :state="stateCirculacionVehiculoPlaca"
                            maxlength="7"
                            placeholder="Buscar Placa..."
                            v-model="placaVehiculo"
                            @change="pitcherReceiverRemitente(3)"
                            @input="mayus()"
                            @keydown="handleKeyDown"
                            @paste="limpiarTextoPegado">
                            </b-form-input>
                            <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                                <b-button
                                v-b-tooltip.hover title="Clic para mostrar listado"
                                @click="listaDeVehiculos()"
                                variant="primary"
                                class="pb-0 pt-0 pl-1 pr-1"
                                size="sm">
                                <i class="fas fa-search"></i>
                                </b-button>
                                <template v-if="listaVehiculo">
                                <b-button v-if="listaVehiculos.length > 0"
                                    v-b-tooltip.hover title="Cerrar Lista"
                                    variant="primary"
                                    size="sm"
                                    class="ml-1 pt-0 pb-0 pl-1 pr-1" 
                                    @click="closeListVehiculo()" >
                                    <i class="fas fa-arrow-up"></i>
                                </b-button>
                                </template>
                            </b-input-group-text>
                        </b-input-group>
                        </b-form-group>
                        <b-list-group v-if="listaVehiculo" class="searcher-fieldplaca">
                            <table v-if="listaVehiculos.length > 0" class="searcher-result3">
                                <tr class="centrarTitulo tablaborde">
                                <th style="width:20%;">Placa</th>
                                <!-- <th style="width:25%;">Código/Alias</th> -->
                                <th style="width:20%;">Ciruculación MTC</th>
                                <th style="width:20%;">Cod. Entidad</th>
                                <th style="width:20%;">Nro. Autorización</th>
                                </tr>
                            </table>
                            <template v-for="(item, index) in listaVehiculos">
                                <table  
                                    @click="setReceiverVehiculo(item)" 
                                    class="searcher-result2" 
                                    :key="index">   
                                    <tr>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.placa}}</td>
                                    <!-- <td style="width:23%;" class="tablaborde ">{{item.codigo}}</td> -->
                                    <td style="width:20%;" class="tablaborde ">{{item.nroCirculacionMTC}}</td>
                                    <td style="width:20%; text-align:center" class="tablaborde ">{{item.idEntidad}}</td>
                                    <td style="width:20%;" class="tablaborde ">{{item.numeroPermiso}}</td>
                                    </tr>
                                </table>
                            </template>
                        </b-list-group> 
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="3">
                        <b-form-group
                        :state="stateCirculacionVehiculo"
                        :invalid-feedback="invalidFeedbackCirculacionVehiculo"
                        :valid-feedback="validFeedbackCirculacionVehiculo">
                            <b-form-input
                            class="bordesYtexto input-buscar"
                            :state="stateCirculacionVehiculo"
                            placeholder="Certificado de Habilitación Vehicular - TUCE"
                            v-model="numCirculacionVehiculo"
                            type="text"
                            @keydown="handleKeyDown"
                            maxlength="40">
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                        <select class="form-control bordesYtexto input-buscar"
                            v-model="codEntidadEmisora">
                            <option
                                v-for="(entidad, index) in infoEntidadEmisora"
                                :value="index"
                                :key="index"
                            >{{ entidad.nombre }}</option>
                        </select>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="3">
                        <b-form-input
                            class="bordesYtexto input-buscar"
                            placeholder="Nro. Autorización emitido por la entidad"
                            v-model="numAutorizacionVehiculo"
                            @keydown="handleKeyDown">
                        </b-form-input>
                    </b-col>
                </b-row>
                <br>
                <!-- vehiculos secundarios -->
                <h5><p class="titulosPrimarios mt-2">Vehículo Secundario <b style="color:black">(Opcional hasta 2 Vehículos, Sólo se usarán más de un vehículo para llevar la carga)</b></p></h5>
                <b-row>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="3">
                         <b-form-group
                            :state="stateCirculacionVehiculoPlacaSecun"
                            :invalid-feedback="invalidFeedbackCirculacionVehiculoPlacaSecun">
                        <b-input-group>
                            <b-form-input
                                class="bordesYtexto input-buscar"
                                maxlength="7"
                                :state="stateCirculacionVehiculoPlacaSecun"
                                :disabled="bloquearCampoVehiSecundario"
                                placeholder="Buscar Placa..."
                                v-model="placaVehiculoSecundario"
                                @change="getReceiverVehiculosSecundarios()"
                                @input="mayus()"
                               @keydown="handleKeyDown"
                               @paste="limpiarTextoPegadoSecundario">
                            </b-form-input>
                            <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                                <b-button
                                    :disabled="bloquearCampoVehiSecundario"
                                    v-b-tooltip.hover title="Clic para mostrar listado"
                                    @click="listaDeVehiculosSecundarios()"
                                    variant="primary"
                                    class="pb-0 pt-0 pl-1 pr-1"
                                    size="sm">
                                    <i class="fas fa-search"></i>
                                </b-button>
                                <template v-if="listaVehiculoSecundario">
                                <b-button v-if="listaVehiculosSecundarios.length > 0"
                                    v-b-tooltip.hover title="Cerrar Lista"
                                    variant="primary"
                                    size="sm"
                                    class="ml-1 pt-0 pb-0 pl-1 pr-1" 
                                    @click="closeListVehiculoSecundario()" >
                                    <i class="fas fa-arrow-up"></i>
                                </b-button>
                                </template>
                            </b-input-group-text>
                        </b-input-group>
                        </b-form-group>
                            <b-list-group v-if="listaVehiculoSecundario" class="searcher-fieldplaca">
                            <table v-if="listaVehiculosSecundarios.length > 0" class="searcher-result3">
                                <tr class="centrarTitulo tablaborde">
                                <th style="width:20%;">Placa</th>
                                <!-- <th style="width:25%;">Código/Alias</th> -->
                                <th style="width:20%;">Ciruculación MTC</th>
                                <th style="width:20%;">Cod. Entidad</th>
                                <th style="width:20%;">Nro. Autorización</th>
                                </tr>
                            </table>
                            <template v-for="(item, index) in listaVehiculosSecundarios">
                                <table  
                                    @click="setReceiverVehiculoSecundario(item)" 
                                    class="searcher-result2" 
                                    :key="index">  
                                    <tr>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.placa}}</td>
                                    <!-- <td style="width:23%;" class="tablaborde ">{{item.codigo}}</td> -->
                                    <td style="width:20%;" class="tablaborde ">{{item.nroCirculacionMTC}}</td>
                                    <td style="width:20%; text-align:center" class="tablaborde ">{{item.idEntidad}}</td>
                                    <td style="width:20%;" class="tablaborde ">{{item.numeroPermiso}}</td>
                                    </tr>
                                </table>
                            </template>
                        </b-list-group>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-form-input
                            class="bordesYtexto input-buscar"
                            :disabled="bloquearCampoVehiSecundario"
                            placeholder="Certificado de Habilitación Vehicular - TUCE"
                            v-model="numCirculacionVehiculoSecundario"
                            @keydown="handleKeyDown">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" sm="8" md="6" lg="6" xl="3">
                        <select class="form-control bordesYtexto input-buscar" 
                                v-model="codEntidadEmisoraSecundario">
                            <option
                                v-for="(entidad, index) in infoEntidadEmisora"
                                :value="index"
                                :key="index"
                            >{{ entidad.nombre }}</option>
                        </select>
                        </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-form-input
                        class="bordesYtexto input-buscar"
                        :disabled="bloquearCampoVehiSecundario"
                         placeholder="Nro. Autorización emitido por la entidad"
                         v-model="numAutorizacionVehiculoSecundario"
                         @keydown="handleKeyDown">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <template v-if="!botonEditar">
                            <b-button
                                v-if="validarCamposVehiculo()"
                                variant="primary"
                                @click="guardarVehiculoSecundario()">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </b-button>
                            <b-button 
                                v-else
                                variant="primary"
                                disabled
                                >
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </b-button>
                        </template>
                        <template v-else>
                            <b-button
                            size="sm"
                            variant="warning"
                            @click="editarVehiculo()">
                                Editar
                            </b-button>
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="12">
                        <b-table v-if="recibeVehiculoSecundario.length>0"
                        class="mt-3"
                        small
                        responsive
                        outlined
                        bordered
                        :items="recibeVehiculoSecundario"
                        :fields="recibeVehiculos_Secundario">
                        <template slot="acciones" slot-scope="row" >
                            <b-button 
                            size="sm"
                            variant="ligth"
                            @click="editarVehiculoSecundario(row.index, row.item)">
                            <i class="fa fa-edit text-primary"></i>
                            </b-button>
                            <b-button 
                            size="sm"
                            variant="ligth"
                            @click="eliminarVehiculoSecundario(row.index)">
                            <i class="fa fa-trash text-danger"></i>
                            </b-button>
                        </template>
                        </b-table>
                    </b-col>
                </b-row>
                <!-- Datos del Conductor -->
                <h5><p class="titulosPrimario">Datos Conductor
                    <b-button 
                        v-b-tooltip.hover title="Máximo hasta 3 conductores | Para conductores, RUC solo con 10,15 y 17"
                        size="sm"
                        variant="ligth">
                        <i class="fa fa-question-circle fa-lg"></i>
                    </b-button>
                    </p>
                </h5>
                <b-row>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-select class="bordesYtexto input-buscar" v-model="tipoDocConductor"
                                  :disabled="bloquearCampoConductor">
                            <option 
                                :value="tipodocumento.tipo" 
                                v-for="tipodocumento in documentoIdentidadGuia" 
                                v-bind:key="tipodocumento.tipo">
                                {{tipodocumento.nombre}}
                            </option>
                        </b-select>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="3">
                        <b-input-group>
                            <b-form-input 
                                class="bordesYtexto input-buscar"
                                :disabled="bloquearCampoConductor"
                                placeholder="Buscar Documento..."
                                type="text"
                                v-model="numDoc"
                                @keydown="handleKeyDown"
                                @change="pitcherReceiverRemitente(2)">
                            </b-form-input>
                            <b-input-group-text class="bordesYtexto input-buscar" v-if="conductoresAsociados.length > 0" slot="prepend">
                                <b-button
                                    :disabled="bloquearCampoConductor"
                                    v-b-tooltip.hover title="Ver lista de conductores asociados a la placa ingresada"
                                    variant="warning"
                                    size="sm"
                                    class="pt-0 pb-0 pl-1 pr-1"
                                    @click="seleccionarConductorAsociado()">
                                    <i class="fa fa-eye" aria-hidden="true"></i>
                                </b-button>
                                <b-button v-if="listaConductorAsociado"
                                        v-b-tooltip.hover title="Cerrar Lista"
                                        variant="warning"
                                        size="sm"
                                        class="ml-1 pt-0 pb-0 pl-1 pr-1" 
                                        @click="closeListConductorAsociado()" >
                                        <i class="fas fa-arrow-up"></i>
                                    </b-button>
                            </b-input-group-text>
                            <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                                <b-button
                                    :disabled="bloquearCampoConductor"
                                    v-b-tooltip.hover title="Clic para mostrar listado"
                                    variant="primary"
                                    size="sm"
                                    class="pb-0 pt-0 pl-1 pr-1" 
                                    @click="listarConductores()">
                                    <i class="fas fa-search"></i>
                                </b-button>
                                <template v-if="listaConductor">
                                    <b-button v-if="listaConductores.length > 0"
                                        v-b-tooltip.hover title="Cerrar Lista"
                                        variant="primary"
                                        size="sm"
                                        class="ml-1 pt-0 pb-0 pl-1 pr-1" 
                                        @click="closeListConductor()" >
                                        <i class="fas fa-arrow-up"></i>
                                    </b-button>
                                </template>
                            </b-input-group-text>
                        </b-input-group>
                        <template>
                            <b-list-group v-if="listaConductor" class="searcher-fieldconductor">
                                <table v-if="listaConductores.length > 0" class="searcher-result3">
                                    <tr class="centrarTitulo tablaborde">
                                    <th style="width:20%;">Documento</th>
                                    <th style="width:20%;">Alias</th>
                                    <th style="width:20%;">Nombres</th>
                                    <th style="width:20%;">Apellidos</th>
                                    <th style="width:20%;">Nro. Licencia</th>
                                    </tr>
                                </table>
                                <template v-for="(item, index) in listaConductores">
                                <table  
                                    @click="setReceiverConductor(item)" 
                                    class="searcher-result2" 
                                    :key="index"> 
                                    <tr>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.nroDocumento}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.codigo}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.nombres}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.apellidos}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.nroLicencia}}</td>
                                    </tr>
                                </table>
                                </template>
                            </b-list-group>
                        </template>
                        <template>
                            <b-list-group v-if="listaConductorAsociado" class="searcher-fieldconductor">
                                <table v-if="conductoresAsociados.length > 0" class="searcher-resultAsociados">
                                    <tr class="centrarTitulo tablaborde">
                                    <th style="width:20%;">Documento</th>
                                    <th style="width:20%;">Alias</th>
                                    <th style="width:20%;">Nombres</th>
                                    <th style="width:20%;">Apellidos</th>
                                    <th style="width:20%;">Nro. Licencia</th>
                                    </tr>
                                </table>
                                <template v-for="(item, index) in conductoresAsociados">
                                <table  
                                    @click="setReceiverConductorAsociado(item)" 
                                    class="searcher-result2" 
                                    :key="index"> 
                                    <tr>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.nroDocumento}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.codigo}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.nombres}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.apellidos}}</td>
                                    <td style="width:20%;" class="tablaborde centrarTitulo">{{item.nroLicencia}}</td>
                                    </tr>
                                </table>
                                </template>
                            </b-list-group>
                        </template>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-form-input
                        class="bordesYtexto input-buscar"
                        :disabled="bloquearCampoConductor"
                        placeholder="Buscar Nombre..."
                        type="text"
                        v-model="nombreConductor"
                        @input="mayus()"
                        @change="getReceiverConductorNombre()">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-form-input
                        class="bordesYtexto input-buscar"
                        :disabled="bloquearCampoConductor"
                        placeholder="Apellidos"
                        type="text"
                        @input="mayus()"
                        v-model="apellidoConductor">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-form-input
                        class="bordesYtexto input-buscar"
                        :disabled="bloquearCampoConductor"
                        placeholder="Licencia"
                        @input="mayus()"
                        v-model="numLicencia">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="1">
                        <template v-if="!botonEditarConductor">
                        <b-button 
                            v-if="validarConductor()"
                            variant="primary" 
                            @click="guardarConductor()">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </b-button>
                        <b-button
                            v-else
                            disabled
                            variant="primary">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </b-button>
                        </template>
                        <template v-else>
                            <b-button 
                            style="width:100%"
                            variant="warning"
                            @click="editarConductor()">
                            Editar
                            </b-button>
                        </template>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col  cols="12" sm="6"	md="4" lg="4" xl="10">
                        <b-table v-if="recibeConductorSecundario.length>0" 
                        class="mt-4"
                        small
                        responsive
                        outlined
                        fixed
                        bordered
                        :items="recibeConductorSecundario"
                        :fields="recibeConductor_Secundario">
                        <template slot="tipoConductor" slot-scope="row">
                            <span v-if="row.item.tipoConductor == 'Principal'">
                                 <b><p class="text-danger">{{row.item.tipoConductor}}</p></b>
                            </span>
                            <span v-else-if="row.item.tipoConductor == 'Secundario'">
                                 <b><p class="text-primary">{{row.item.tipoConductor}}</p></b>
                            </span>
                        </template>
                        <template slot="tipoDocumentoConductor" slot-scope="row">
                           <div v-if="row.item.tipoDocumentoConductor == '1'">DNI</div>
                           <div v-if="row.item.tipoDocumentoConductor == '6'">RUC</div>
                           <div v-if="row.item.tipoDocumentoConductor == '4'">Carnet de Extranjeria</div>
                           <div v-if="row.item.tipoDocumentoConductor == '7'">Pasaporte</div>
                           <div v-if="row.item.tipoDocumentoConductor == 'A'">Cedula Diplomatica de Identidad</div>
                           <div v-if="row.item.tipoDocumentoConductor == 'B'">DOC.IDENT.PAIS.RESIDENCIA-NO.D</div>
                           <div v-if="row.item.tipoDocumentoConductor == 'C'">Doc Trib PP.NN</div>
                           <div v-if="row.item.tipoDocumentoConductor == 'D'">Doc Trib PP. JJ</div>
                           <div v-if="row.item.tipoDocumentoConductor == 'E'">TAM- Tarjeta Andina de Migración</div>
                        </template>
                        <template slot="acciones" slot-scope="row" >
                            <b-button 
                            size="sm"
                            variant="ligth"
                            @click="editarDatosConductor(row.index, row.item)">
                            <i class="fa fa-edit text-primary"></i>
                            </b-button>
                            <b-button v-if="row.item.tipoConductor !='Principal'"
                            size="sm"
                            variant="ligth"
                            @click="eliminarConductor(row.index)">
                            <i class="fa fa-trash text-danger"></i>
                            </b-button>
                        </template>
                        </b-table>
                    </b-col>
                </b-row>
                </b-card>
                <b-card style="border: #00b3b3 3px solid;">
                <b-row>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="12">
                         <h5><p class="titulosPrimario">Datos Generales</p></h5>
                        <b-row>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="2">
                                <b-form-input
                                    class="bordesYtexto input-buscar"
                                    placeholder="Peso Bruto(KG)"
                                    v-model="pesoBrutoTotal"
                                    @keydown="handleKeyDownSoloNumero"
                                    type="number">
                                </b-form-input>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="2">
                                <datepicker
                                    class="bordesYtexto input-buscar"
                                    placeholder="Fecha Inicio de Traslado"
                                    v-model="fechaInicioTraslado"
                                    :bootstrap-styling="true"          
                                    :language="es" 
                                    :format="customFormatter">
                                </datepicker>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="3">
                                <b-form-checkbox v-model="indicarTrasladoTotalBienes">
                                    Traslado total de bienes
                                </b-form-checkbox>
                                <b-form-checkbox v-model="indicadorRetornoVehiculoEnvases">
                                    Retorno vehículo con envases o embalajes vacíos
                                </b-form-checkbox>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="3">
                                <b-form-checkbox v-model="indicadorTransbordoProgramado">
                                    Indicador de transbordo programado
                                </b-form-checkbox>
                                <b-form-checkbox v-model="indicadorTransporteSubcontratado">
                                    Indicador de transporte subcontratado
                                </b-form-checkbox>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="2">
                                <b-form-checkbox v-model="indicadorRetornoVehiculoVacio">
                                    Retorno vehículo vacío
                                </b-form-checkbox>
                                <!-- <h6><p style="color:red">Obligatorio en caso subcontrato</p></h6> -->
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col cols="12" sm="6" md="4" lg="4" xl="3">
                                <b-form-select class="bordesYtexto input-buscar" v-model="indicadorPagadorFlete" :options="optionsIndicador"></b-form-select>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="3">
                               <b-select class="bordesYtexto input-buscar" :disabled="bloquearFleteRUC" v-model="tipoDocumentoFlete">
                                    <option 
                                        :value="tipoDocumento.tipo" 
                                        v-for="tipoDocumento in documentoIdentidadGuia" 
                                        v-bind:key="tipoDocumento.tipo">
                                        {{tipoDocumento.nombre}}
                                    </option>
                                </b-select>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="3">
                                <b-form-input
                                    class="bordesYtexto input-buscar"
                                    :disabled="bloquearFlete"
                                    placeholder="Buscar..."
                                    type="number"
                                    v-model="nroFlete"
                                    @change="pitcherReceiverRemitente(4)">
                                </b-form-input>
                                <b-list-group v-if="listaRemitenteFlete" class="searcher-field">
                                    <b-list-group-item 
                                        v-for="(item, index) in listaRemitentesFlete"
                                        :key="index" @click="setReceiverRemitenteFlete(item)" 
                                        class="searcher-result">
                                        {{item.idReceptor + ' - ' + item.razonSocial}}
                                    </b-list-group-item>
                                </b-list-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="3">
                               <b-form-input 
                                    class="bordesYtexto input-buscar"
                                    :disabled="bloquearFlete" 
                                    v-model="razonSocialFlete"
                                    placeholder="Razón Social">
                                </b-form-input>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="mt-4">
                <b-col cols="12" sm="6"	md="4" lg="4" xl="12">
                         <h5><p class="titulosPrimario">Documentos Relacionados 
                         </p></h5>    
                        <b-row>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="2">
                                <b-input-group>
                                    <b-form-input
                                    class="bordesYtexto input-buscar"
                                    placeholder="RUC"
                                    v-model="numDocRelacionado">
                                    </b-form-input>
                                    <b-input-group-text slot="append" v-if="copiarDocRemitente">
                                       <b-button
                                       v-b-tooltip.hover.top="'Copiar documento remitente'"
                                        variant="primary"
                                        size="sm"
                                        class="pl-1 pr-1 pt-0 pb-0"
                                        @click="copiarDoc()">
                                        <i class="fa fa-clone" aria-hidden="true"></i>
                                       </b-button>
                                    </b-input-group-text>
                                </b-input-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="2">
                               <b-select class="bordesYtexto input-buscar" v-model="docRelacionado">
                                <option 
                                    :value="documento.codigo" 
                                    v-for="documento in documentoRelacionadoGuia" 
                                    v-bind:key="documento.codigo">
                                    {{documento.nombre}}
                                </option>
                                </b-select>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="2">
                                <b-form-input 
                                class="bordesYtexto input-buscar"
                                type="text"
                                placeholder="Número"
                                @input="mayus()"
                                @keydown="guionNumero"
                                v-model="serieNumero">
                                </b-form-input>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="4">
                                <b-input-group>
                                    <b-form-input
                                        class="bordesYtexto input-buscar"
                                        v-model="descripcionDoc"
                                        @input="contadorCaracteres(1)"
                                        id="textarea-small"
                                        placeholder="Ingresar descripción... (120 caracteres)"
                                        maxlength="120">
                                    </b-form-input>
                                    <b-input-group-text slot="prepend" class="pt-0 pb-0 bordesYtexto input-buscar">
                                        {{contador}}
                                    </b-input-group-text>
                                </b-input-group>   
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="1">
                                <b-button
                                    :disabled="validarAddDoc()"
                                    @click="addDocRelacion()"
                                    v-b-tooltip.hover.top="'Agregar Documento Relacionado'"
                                    variant="primary">
                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col cols="12" sm="6" md="4" lg="4" xl="12">
                                <b-table v-if="reciveDocRelacion.length > 0"
                                    outlined                           
                                    small
                                    :items="reciveDocRelacion"
                                    :fields="reciveDocRelacion_lista">
                                    <template slot="acciones">
                                        <b-button
                                        variant="ligth"
                                        size="sm"
                                        @click="eliminarDocRelacion(index)">
                                        <i class="fa fa-trash text-danger" aria-hidden="true"></i>
                                        </b-button>
                                    </template>
                                    <template slot="codigo" slot-scope="row">
                                        <p v-if="row.item.codigo == '01'">Factura</p>
                                        <p v-if="row.item.codigo == '03'">Boleta de venta</p>
                                        <p v-if="row.item.codigo == '07'">Nota de crédito</p>
                                        <p v-if="row.item.codigo == '08'">Nota de débito</p>
                                        <p v-if="row.item.codigo == '09'">Guía de remisión remitente</p>
                                        <p v-if="row.item.codigo == '16'">Boleto de viaje emitido por las empresas de transporte público interprovincial de pasajeros</p>
                                        <p v-if="row.item.codigo == '21'">Conocimiento de embarque por el servicio de transporte de carga marítima</p>
                                        <p v-if="row.item.codigo == '23'">Pólizas de Adjudicación por remate o adjudicación de bienes</p>
                                        <p v-if="row.item.codigo == '28'">Etiquetas por el pago de la Tarifa Unificada de Uso de Aeropuerto – TUUA</p>
                                        <p v-if="row.item.codigo == '30'">Documentos de pago con tarjetas de crédito y débito</p>
                                        <p v-if="row.item.codigo == '31'">Guía de remisión transportista</p>
                                        <p v-if="row.item.codigo == '43'">Boleto de compañías de aviación transporte aéreo no regular</p>
                                        <p v-if="row.item.codigo == '04'">Liquidación de compra</p>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                        <i>Nota: EL DESTINATARIO DEL DOCUMENTO RELACIONADO Y EL REMITENTE DE LA GUÍA TRANSPORTISTA DEBE SER EL MISMO</i>
                        <b-row class="mt-3">
                            <b-col  cols="12" sm="6" md="4" lg="4" xl="11">
                            <b-input-group>
                                <b-form-input
                                    class="bordesYtexto input-buscar"
                                    @input="contadorCaracteres(2)"
                                    placeholder="(OPCIONAL) Observaciones Generales de la Guia ( max. 250 caracteres)"
                                    v-model="observaciones"
                                    id="textarea-small"
                                    maxlength="250"/>
                                <b-input-group-text  slot="prepend" class="pt-0 pb-0 bordesYtexto input-buscar">
                                    {{contadorObservaciones}}
                                </b-input-group-text>
                            </b-input-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                </b-card>
                <b-card style="border: #00b3b3 3px solid;">
                <h5><p class="titulosPrimario">Items</p></h5>
                <b-row>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="1">
                        <b-form-input
                        class="bordesYtexto input-buscar"
                        type="text"
                        v-model="cantidad"
                        @keydown="numeroPunto"
                        placeholder="Cantidad">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-select class="bordesYtexto input-buscar" v-model="unidadMedidaCantidad">                       
                            <option 
                                :value="unidad.codigo" 
                                v-for="unidad in unidades" 
                                v-bind:key="unidad.id">
                                {{ unidad.descripcion }}
                            </option>
                        </b-select> 
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                        <b-input-group>
                            <b-form-input
                                    placeholder="Descripción Producto"
                                    maxlength="500"
                                    v-model="descripcion"
                                    @keydown="tecla"
                                    class="bordesYtexto input-buscar"
                                    type="text"
                            ></b-form-input>
                            <b-input-group-text class="bordesYtexto input-buscar" slot="append">
                                <button class="btn btn-warning btn-sm sinresultados" @click="cerrarresultados">
                                    <i class="fa fa-times"></i>
                                </button>
                            </b-input-group-text>
                        </b-input-group>
                        <template v-if="cargandoDescription">
                            <b-list-group-item>
                            Buscando
                            <i class="fa fa-spin fa-spinner"></i>
                            </b-list-group-item>
                        </template>
                        <b-list-group v-if="listades" class="searcher-field">
                            <template v-if="!nuevaBusqueda">
                                <table v-if="listaDescription.length > 0" class="searcher-result3">
                                <tr class="centrarTitulo tablaborde">
                                    <th style="width:50%;">Productos</th>
                                    <th style="width:8%;">Precio</th>
                                    <th style="width:5%;">Costo</th>
                                    <th style="width:10%;">Código</th>
                                </tr>
                                </table>
                                <template v-for="(item, index) in opcionesOrdenadas">
                                <table
                                    @click="agregarItem(item)" 
                                    class="searcher-result2" 
                                    :key="index">  
                                    <tr>
                                    <td style="width:50%;" class="tablaborde ">{{item.descripcion.toUpperCase()}}</td>
                                    <td style="width:8%;" class="tablaborde centrarTitulo">{{item.precioUnitario}}</td>
                                    <td style="width:5%;color:red" class="tablaborde centrarTitulo">{{item.precioCosto}}</td>
                                    <td style="width:10%;" class="tablaborde centrarTitulo">{{item.codigo}}</td>
                                    </tr>
                                </table>
                                </template>
                            </template> 
                        </b-list-group>
                        <template>
                            <div v-if="cargandoInformacion">
                                <b-list-group-item>Cargando Informacion <i class="fa fa-spin fa-spinner"></i></b-list-group-item> 
                            </div>
                        </template>
                        <!-- <b-input-group>
                             <b-form-input
                                class="bordesYtexto input-buscar"
                                placeholder="Descripcion Item"
                                maxlength="500"
                                v-model="descripcion"
                                @keydown="tecla">
                            </b-form-input>
                            <b-input-group-text class="bordesYtexto input-buscar" v-if="listades" slot="append">
                                <b-button 
                                    v-b-tooltip.hover title="Cerrar Lista"
                                    variant="primary"
                                    class="pb-0 pt-0 pl-1 pr-1"
                                    size="sm"
                                    @click="cerraListaProductos()">
                                    <i class="fas fa-arrow-up"></i>
                                </b-button>
                            </b-input-group-text>
                        </b-input-group>
                        <b-list-group v-if="listades" class="searcher-field">                            
                            <table v-if="listProductos.length > 0" class="searcher-result3">
                                <tr class="centrarTitulo tablaborde">
                                <th style="width:50%;">Productos</th>
                                <th style="width:10%;">Código</th>
                                </tr>
                            </table>
                            <template v-for="(item, index) in listProductos">
                                <table  
                                    @click="setReceiverDescription(item)" 
                                    class="searcher-result2" 
                                    :key="index">  
                                    <tr>
                                    <td style="width:50%;" class="tablaborde ">{{item.descripcion.toUpperCase()}}</td>
                                    <td style="width:10%;" class="tablaborde centrarTitulo">{{item.codigo}}</td>
                                    </tr>
                                </table>
                            </template>
                        </b-list-group>  -->
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-form-input 
                            class="bordesYtexto input-buscar"
                            v-model="codigoItem"
                            placeholder="Codigo Item"
                             @input="getReceiversCodigoInterno()">
                        </b-form-input>
                        <b-list-group v-if="listCodigoInterno" class="searcher-field">                           
                            <b-list-group-item 
                                v-for="(item, index) in listaCodigoInterno" 
                                :key="index" @click="setReceiverCodigoInterno(item)" 
                                class="searcher-result">
                                {{item.codigo + ' - ' + item.descripcion}}
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-form-input
                            class="bordesYtexto input-buscar"
                            v-model="codigoSunat"
                            maxlength="8"
                            placeholder="Cod. SUNAT">
                        </b-form-input>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4"	lg="4"	xl="1">
                        <b-form-checkbox v-model="adicionalesItemsGuia" @click="!adicionalesItemsGuia">
                                Adicionales
                        </b-form-checkbox>
                    </b-col>
                </b-row>
                <br>
                <template v-if="adicionalesItemsGuia">
                    <b-row>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                            <b-alert show>
                                <b-row>
                                    <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4">
                                        <b-form-input
                                            v-model="lote"
                                            type="text"
                                            required
                                            class="bordesYtexto input-buscar"
                                            placeholder="Lote">
                                        </b-form-input>
                                    </b-col>
                                    <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4">
                                        <b-form-input
                                            v-model="peso"
                                            type="text"
                                            required
                                            class="bordesYtexto input-buscar"
                                            placeholder="Peso">
                                        </b-form-input>
                                    </b-col>
                                    <!-- <b-col cols="12" sm="6"	md="4"	lg="4"	xl="4">
                                        <datepicker 
                                            class="bordesYtexto input-buscar"
                                            v-model="fvencimientoItem" 
                                            :format="customFormatter" 
                                            :language="es" 
                                            :bootstrap-styling="true" 
                                            :disabledDates="diasnopermitidos" 
                                            placeholder="Fecha de Vencimiento">
                                        </datepicker>
                                    </b-col> -->
                                </b-row>
                            </b-alert>
                        </b-col>
                    </b-row>
                </template>      
                <br>
                <b-row>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="4"></b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                        <b-button v-if="!mostrarEdit"
                            :disabled="validarItems()"
                            style="width:100%"
                            variant="primary"
                            @click="addItems()">
                            Agregar
                            <i class="fa fa-plus"></i>
                        </b-button>
                        <b-button v-else
                            style="width:100%"
                            variant="warning"
                            @click="editarItemProducto()">
                            Editar
                        </b-button>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="4"></b-col>
                </b-row>
                <br>
                <b-row>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="12">
                        <b-table
                            responsive
                            small
                            outlined
                            fixed
                            bordered
                            :items="productosLista"
                            :fields="productos_Lista">
                            <template slot="acciones" slot-scope="row" >
                                <b-button 
                                    size="sm"
                                    variant="ligth"
                                    @click="editarItems(row.index, row.item)">
                                    <i class="fa fa-edit text-primary"></i>
                                </b-button>
                                <b-button
                                    size="sm"
                                    variant="ligth"
                                    @click="eliminarItems(row.index)">
                                    <i class="fa fa-trash text-danger"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </b-col>
                </b-row>
                </b-card>
                <b-row>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="9"></b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="1">
                        <b-button 
                            variant="success"
                            :disabled="validarEnvioGuia()"
                            @click="validaVistaPrevia()"
                            >Previsualizar</b-button>
                    </b-col>
                    <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                        <b-button v-if="!emitiendo"
                            :disabled="validarEnvioGuia()"
                            variant="primary"
                            @click="emitirGuiaTransportista()">
                            Emitir <i class="fa fa-paper-plane" aria-hidden="true"></i>
                        </b-button>
                        <b-button v-else
                            disabled
                            variant="primary">
                            Emitiendo... <i class="fa fa-spin fa-spinner"></i>
                        </b-button>
                    </b-col>    
                </b-row>
                <!-- MODAL PREVISUALIZACION -->
                <b-modal size="xl" v-model="previaEmision">
                    <template slot="modal-title">
                        Vista Pre-Emision (Guia Transportista)
                    </template>
                    <div class="p-2">
                    <b-row>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                            <div class="Subtitulos">
                                Datos Remitente
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="ml-3 mt-2">
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                            <div>
                                <b>Num. Documento:</b> {{remitente.numero}} 
                            </div>
                        </b-col>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="5">
                            <div>
                                <b>Razon Social:</b> {{remitente.razonSocial}}
                            </div>
                        </b-col>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="5">
                            <div>
                               <b>Direccion:</b> {{remitente.direccion}}
                            </div>
                        </b-col>
                    </b-row>
                    <br>
                    <b-row>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                           <div class="Subtitulos">
                             Datos Destinatario
                           </div>
                        </b-col>
                    </b-row>
                    <b-row class="ml-3 mt-2">
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                            <div>
                                <b>Num. Documento:</b> {{receptor.numero}}
                            </div>
                        </b-col>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="5">
                            <div>
                                <b>Razon Social:</b> {{receptor.razonSocial}}
                            </div>
                        </b-col>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="5">
                            <div>
                               <b>Direccion:</b> {{receptor.direccion}}
                            </div>
                        </b-col>
                    </b-row>
                    <br>
                    <b-row>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                          <div class="Subtitulos">
                              Datos Ubicación
                          </div>
                        </b-col>
                    </b-row>
                    <b-row class="ml-3 mt-2">
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                            <div>
                               <b>Ubigeo Partida:</b> {{ubigeoPartida}}
                            </div>
                        </b-col>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                            <div>
                              <b>Direccion Partida:</b> {{this.mostrarubigeoTexto == true ? this.direccionPartidaTexto : this.listUbigeo[this.direccionPartidaSelector].direccion}}
                            </div>
                        </b-col>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                            <div>
                                <b>Ubigeo Llegada:</b> {{ubigeoLlegada}}
                            </div>
                        </b-col>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                            <div>
                              <b>Dirección Llegada:</b> 
                              <template>
                                <div v-if="capturaDireccionesLlegada.length > 0">
                                    {{this.mostrarubigeoTextoLlegada == true ? this.direccionLlegadaTexto : this.capturaDireccionesLlegada[this.direccionLlegadaSelector].direccion}}
                                </div>
                                <div v-else>
                                    {{this.direccionLlegadaTexto}}
                                </div>
                              </template>
                            </div>
                        </b-col>
                    </b-row>
                    <hr style="background-color:black">
                    <b-row>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="3">
                            <div class="Subtitulos">
                                Vehiculo Principal
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="ml-3 mt-2">
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                            <div>
                                <b>Placa: </b> {{placaVehiculo}}
                            </div>
                        </b-col>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="5">
                            <div>
                               <b>Certificado de Habilitación Vehicular - TUCE: </b> {{numCirculacionVehiculo}}
                            </div>
                        </b-col>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="5">
                            <div v-if="codEntidadEmisora =='01'" >
                                <b>Entidad Emisora: </b> Superintendencia Nacional de Control de Servicios de Seguridad, Armas, Municiones y Explosivos de Uso Civil
                            </div>
                            <div v-if="codEntidadEmisora =='02'" >
                                <b>Entidad Emisora: </b> Dirección General de Medicamentos Insumos y Drogas 
                            </div>
                            <div v-if="codEntidadEmisora =='03'" >
                                <b>Entidad Emisora: </b> Dirección General de Salud Ambiental
                            </div>
                            <div v-if="codEntidadEmisora =='04'" >
                                <b>Entidad Emisora: </b> Servicio Nacional de Sanidad Agraria
                            </div>
                            <div v-if="codEntidadEmisora =='05'" >
                                <b>Entidad Emisora: </b> Servicio Nacional Forestal y de Fauna Silvestre
                            </div>
                            <div v-if="codEntidadEmisora =='06'" >
                                <b>Entidad Emisora: </b> Ministerio de Transportes y Comunicaciones
                            </div>
                            <div v-if="codEntidadEmisora =='07'" >
                                <b>Entidad Emisora: </b> Ministerio de la Producción
                            </div>
                            <div v-if="codEntidadEmisora =='08'" >
                                <b>Entidad Emisora: </b> SMinisterio del Ambiente
                            </div>
                            <div v-if="codEntidadEmisora =='09'" >
                                <b>Entidad Emisora: </b> Organismo Nacional de Sanidad Pesquera
                            </div>
                            <div v-if="codEntidadEmisora =='10'" >
                                <b>Entidad Emisora: </b> Municipalidad Metropolitana de Lima
                            </div>
                            <div v-if="codEntidadEmisora =='11'" >
                                <b>Entidad Emisora: </b> Ministerio de Salud
                            </div>
                            <div v-if="codEntidadEmisora =='12'" >
                                <b>Entidad Emisora: </b> Gobierno Regional
                            </div>
                        </b-col>
                    </b-row>
                    <br>
                    <template v-if="recibeVehiculoSecundario.length > 0">
                    <b-row>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="3">
                            <div class="Subtitulos">
                                Vehiculo Secundario
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="ml-3 mt-2">
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="12">
                            <b-table disabled
                                small
                                responsive
                                outlined
                                bordered
                                :items="recibeVehiculoSecundario"
                                :fields="recibeVehiculos_SecundarioPreEmision">
                            </b-table>
                        </b-col>
                    </b-row>
                    </template>
                    <b-row>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                           <div class="Subtitulos">
                             Conductor
                           </div>
                        </b-col>
                    </b-row>
                    <b-row class="ml-3 mt-2">
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="12">
                           <b-table disabled
                            small
                            responsive
                            outlined
                            fixed
                            bordered
                            :items="recibeConductorSecundario"
                            :fields="recibeConductor_SecundarioPreEmision">
                            <template slot="tipoConductor" slot-scope="row">
                                <span v-if="row.item.tipoConductor == 'Principal'">
                                    <b><p class="text-danger">{{row.item.tipoConductor}}</p></b>
                                </span>
                                <span v-else-if="row.item.tipoConductor == 'Secundario'">
                                    <b><p class="text-primary">{{row.item.tipoConductor}}</p></b>
                                </span>
                            </template>
                            <template slot="tipoDocumentoConductor" slot-scope="row">
                                <div v-if="row.item.tipoDocumentoConductor == '1'">DNI</div>
                                <div v-if="row.item.tipoDocumentoConductor == '6'">RUC</div>
                                <div v-if="row.item.tipoDocumentoConductor == '4'">Carnet de Extranjeria</div>
                                <div v-if="row.item.tipoDocumentoConductor == '7'">Pasaporte</div>
                                <div v-if="row.item.tipoDocumentoConductor == 'A'">Cedula Diplomatica de Identidad</div>
                                <div v-if="row.item.tipoDocumentoConductor == 'B'">DOC.IDENT.PAIS.RESIDENCIA-NO.D</div>
                                <div v-if="row.item.tipoDocumentoConductor == 'C'">Doc Trib PP.NN</div>
                                <div v-if="row.item.tipoDocumentoConductor == 'D'">Doc Trib PP. JJ</div>
                                <div v-if="row.item.tipoDocumentoConductor == 'E'">TAM- Tarjeta Andina de Migración</div>
                            </template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <hr style="background-color:black">
                    <b-row>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="2">
                            <div class="Subtitulos">Datos Generales</div>
                        </b-col>
                    </b-row>
                    <b-row class="ml-3 mt-2">
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                            <b>Peso Bruto(KG):</b> {{pesoBrutoTotal}}
                        </b-col>
                        <b-col cols="12" sm="6"	md="4" lg="4" xl="4">
                            <b>Fecha Inicio de Traslado:</b> {{fechaInicioTraslado}}
                        </b-col>
                    </b-row>
                    <template>
                        <b-row class="ml-3 mt-2">
                            <b-col cols="12" sm="6" md="4" lg="4" xl="3">
                                <b-form-checkbox v-if="indicarTrasladoTotalBienes" disabled v-model="indicarTrasladoTotalBienes">
                                    Traslado total de bienes
                                </b-form-checkbox>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="3">
                                <b-form-checkbox v-if="indicadorRetornoVehiculoEnvases" disabled v-model="indicadorRetornoVehiculoEnvases">
                                    Retorno vehículo con envases o embalajes vacíos
                                </b-form-checkbox>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="3">
                                <b-form-checkbox v-if="indicadorTransbordoProgramado" disabled v-model="indicadorTransbordoProgramado">
                                    Indicador de transbordo programado
                                </b-form-checkbox>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="3">
                                <b-form-checkbox v-if="indicadorTransporteSubcontratado" disabled v-model="indicadorTransporteSubcontratado">
                                    Indicador de transporte subcontratado
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                        <b-row class="ml-3 mt-2">
                            <b-col cols="12" sm="6" md="4" lg="4" xl="3">
                                <b-form-checkbox v-if="indicadorRetornoVehiculoVacio" disabled v-model="indicadorRetornoVehiculoVacio">
                                    Retorno vehículo vacío
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                    </template>
                    <b-row class="ml-3 mt-3">
                        <b-col v-if="indicadorPagadorFlete !=0" cols="12" sm="6" md="4" lg="4" xl="4">
                           <b>Tipo Flete:</b> {{optionsIndicador[indicadorPagadorFlete].text}}
                        </b-col>
                        <b-col v-if="nroFlete!=''" cols="12" sm="6" md="4" lg="4" xl="3">
                           <b>Num. Documento:</b> {{nroFlete}}
                        </b-col>
                        <b-col v-if="razonSocialFlete!=''" cols="12" sm="6" md="4" lg="4" xl="3">
                           <b>Razon Social:</b> {{razonSocialFlete}}
                        </b-col>
                    </b-row>
                    <br>
                    <template v-if="reciveDocRelacion.length > 0">
                    <b-row>
                        <b-col cols="12" sm="6" md="4" lg="4" xl="3">
                            <div class="Subtitulos">
                                Documentos Relacionados
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="ml-3 mt-2">
                        <b-col cols="12" sm="6" md="4" lg="4" xl="12">
                            <b-table 
                            disabled
                            outlined
                            bordered
                            responsive                      
                            small
                            :items="reciveDocRelacion"
                            :fields="reciveDocRelacion_listaPreEmision">
                            <template slot="codigo" slot-scope="row">
                                <p v-if="row.item.codigo == '01'">Factura</p>
                                <p v-if="row.item.codigo == '03'">Boleta de venta</p>
                                <p v-if="row.item.codigo == '07'">Nota de crédito</p>
                                <p v-if="row.item.codigo == '08'">Nota de débito</p>
                                <p v-if="row.item.codigo == '09'">Guía de remisión remitente</p>
                                <p v-if="row.item.codigo == '16'">Boleto de viaje emitido por las empresas de transporte público interprovincial de pasajeros</p>
                                <p v-if="row.item.codigo == '21'">Conocimiento de embarque por el servicio de transporte de carga marítima</p>
                                <p v-if="row.item.codigo == '23'">Pólizas de Adjudicación por remate o adjudicación de bienes</p>
                                <p v-if="row.item.codigo == '28'">Etiquetas por el pago de la Tarifa Unificada de Uso de Aeropuerto – TUUA</p>
                                <p v-if="row.item.codigo == '30'">Documentos de pago con tarjetas de crédito y débito</p>
                                <p v-if="row.item.codigo == '31'">Guía de remisión transportista</p>
                                <p v-if="row.item.codigo == '43'">Boleto de compañías de aviación transporte aéreo no regular</p>
                                <p v-if="row.item.codigo == '04'">Liquidación de compra</p>
                            </template>
                        </b-table>
                        </b-col>
                    </b-row>
                    </template>
                    <hr style="background-color:black">
                    <b-row>
                        <b-col cols="12" sm="6" md="4" lg="4" xl="2">
                            <div class="Subtitulos">Items</div>
                        </b-col>
                    </b-row>
                    <b-row class="ml-3 mt-2">
                        <b-col cols="12" sm="6" md="4" lg="4" xl="12">
                            <b-table disabled
                                responsive
                                small
                                outlined
                                fixed
                                bordered
                                :items="productosLista"
                                :fields="productos_ListaPreEmision">
                            </b-table>
                        </b-col>
                    </b-row>
                    </div>
                    <template>
                        <div style="width:100%" slot="modal-footer">
                          <b-row>
                             <b-col cols="12" sm="6" md="4" lg="4" xl="10">
                               <div>
                                  <b-button
                                        size="lg"
                                        variant="dark"
                                        @click="cerrarVistaPrevia()">
                                        Cerrar
                                </b-button>
                               </div>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" lg="4" xl="2">
                                <div>
                                    <b-button v-if="!emitiendo"
                                        size="lg"
                                        :disabled="validarEnvioGuia()"
                                        variant="primary"
                                        @click="emitirGuiaTransportista()">
                                        Emitir <i class="fa fa-paper-plane" aria-hidden="true"></i>
                                    </b-button>
                                    <b-button v-else
                                        size="lg"
                                        disabled
                                        variant="primary">
                                        Emitiendo... <i class="fa fa-spin fa-spinner"></i>
                                    </b-button>
                                </div>
                            </b-col>
                          </b-row>
                        </div>
                    </template>
                </b-modal>
                <b-modal v-model="modalError500">
                    <b-alert show variant="danger">
                    <div class="text-center">
                        <strong>    
                            <i class="fa fa-2x fa-exclamation-circle"></i>
                            Error 500 - Error en el servidor
                        </strong>
                        <p>Si el mensaje se vuelve a mostrar, por favor notificar al área de soporte.</p> 
                        <i class="fas fa-file-code" @click="copyJsonToClipboard" style="cursor: pointer;"></i> JSON
                    </div>
                    </b-alert>
                    <template v-slot:modal-footer>
                        <b-button block variant="primary" @click="refreshPage">Actualizar y volver a intentar</b-button>
                    </template>
                </b-modal>
            </div>
        </b-card>
        <b-card v-else-if="ocultarGuiaTransportista">    
            <b-alert show>
            <h3>
                Por favor registrar las Credenciales de SUNAT <b-img style="width:2%; height:10% " src="images/sunat.png"/> para habilitar las Guías de Transportista. 
                <b-button 
                    size="sm" 
                    variant="primary" 
                    @click="irAOpcionesSunat()">
                    Click Aquí 
                    <i class="fa fa-university" aria-hidden="true"></i>
                </b-button>
                </h3>
            </b-alert>
        </b-card>
        </div>
        <vue-snotify></vue-snotify>
        <template v-if="postEmision">
            <vista-post-emison :idDocumentPreview="idDocumentPreview" :tipoDocPreview="tipoDocPreview"></vista-post-emison>
        </template>
    </div>
</template>
<script>
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
import {es} from 'vuejs-datepicker/dist/locale'
import { UnidadMedida } from '@/shared/utils'
import GuiaRemisionTransportistaEmision from '@/components/guiaremisiontransportista/GuiaRemisionTransportistaEmision.vue'
import { DocumentosIdentidadGuia } from '@/shared/utils'
import { documentoRelacionado } from '@/shared/utils'
import vistaPostEmision from '@/components/comunes/VistaPostEmision'
import { entidadEmisora } from "@/shared/utils";
export default {
    name: GuiaRemisionTransportistaEmision,
    components:{
        GuiaRemisionTransportistaEmision,
        Datepicker,
        'vista-post-emison': vistaPostEmision,
    },
    data() {
        return {
            cargando:true,
            infoEntidadEmisora:entidadEmisora,
            ocultarGuiaTransportista:true,
            es:es,
            tipoDocumento:6,
            tipoDocumentoRemitente: 6,
            docRelacionado:0,
            documentoRelacionadoGuia:documentoRelacionado,
            documentoIdentidadGuia: DocumentosIdentidadGuia,
            listDepartamento: [],
            listProvinceOrigen: [],
            listDistrictOrigen: [],
            tipoDocumentoGuia:"31",
            pesoBrutoTotal:"",
            receptor: {
                tipo:'',
                numero:'',
                razonSocial:'',
                direccion:''                               
            },
            remitente: {
                tipo:'',
                numero:'',
                razonSocial:'',
                direccion:''                               
            },
            listaReceptores: [],
            listaRemitentes: [],
            direcciones: [],
            listaSeries: [],
            listaReceptor:false,
            listaRemitente:false,
            listadni:[],
            mostrardniRemitente:false,
            buscandoRemitente:false,
            buscandoReceptor:false,
            listadniReceptor:[],
            mostrardniReceptor:false,
            listaConductores:[],
            listaConductor:false,
            listaVehiculos:[],
            listaVehiculo:false,
            listaVehiculosSecundarios:[],
            listaVehiculoSecundario:false,
            listaEntidades:[],
            listaEntidad:false,
            verDirecciones:false,
            verDireccionesRemitente:false,
            serieInicial:0,
            ubigeoPartida:'',
            ubigeoLlegada:'',
            departamentoSeleccionadoUbigeoOrigen: '',
            provinciaSeleccionadaUbigeoOrigen:'',
            distritoSeleccionadoUbigeoOrigen:'',
            provOrigen: false,
            provLlegada: false,
            modalUbigeoPartida:false,
            provDestino: false, 
            provOrigenCargando:false,
            provLlegadaCargando:false,
            distOrigen:false,
            distLlegada:false,
            distOrigenCargando:false,
            distLlegadaCargando:false,
            modalUbigeoLlegada: false,
            departamentoSeleccionadoUbigeoLlegada: '',
            provinciaSeleccionadaUbigeoLlegada:'',
            distritoSeleccionadoUbigeoLlegada:'',
            mostrarubigeoTexto:true,
            mostrarubigeoTextoLlegada:true,
            direccionPartidaTexto:'',
            direccionLlegadaTexto:'',
            direccionPartidaSelector:null,
            direccionLlegadaSelector:null,
            listUbigeo:[],
            listUbigeoLlegada:[],
            listDepartamentoLlegada: [],
            listProvinceLlegada: [],
            listDistrictLlegada: [],
            placaVehiculo:'',
            numCirculacionVehiculo:'',
            codEntidadEmisora:0,
            numAutorizacionVehiculo:'',
            vSecunUno:false,
            vSecunDos:false,
            placaVehiculoSecundario:'',
            numCirculacionVehiculoSecundario:'',
            codEntidadEmisoraSecundario:0,
            numAutorizacionVehiculoSecundario:'',
            tipoDocConductor:1,
            numDoc:'',
            nombreConductor:'',
            apellidoConductor:'',
            numLicencia:'',
            cantidad:1,
            unidadMedidaCantidad:'NIU',
            unidades: UnidadMedida,
            descripcion:'',
            listades: false,
            listProductos:[],
            productosLista:[],
            productos_Lista:[
                { key: "cantidad", label:"Cantidad", sortable:true},
                { key: "unidadMedida", label:"Unidad Medida", sortable:true},
                { key: "descripcion", label:"Producto", sortable:true},
                { key: "codItem", label:"Codigo Item", sortable:true},
                { key: "codSunat", label:"Codigo Sunat", sortable:true},
                { key: "acciones", label:"Editar / Eliminar"}
            ],
            productos_ListaPreEmision:[
                { key: "cantidad", label:"Cantidad", sortable:true},
                { key: "unidadMedida", label:"Unidad Medida", sortable:true},
                { key: "descripcion", label:"Producto", sortable:true},
                { key: "codItem", label:"Codigo Item", sortable:true},
                { key: "codSunat", label:"Codigo Sunat", sortable:true},
            ],
            descripcion: '',
            codigoItem: '',
            listaCodigoInterno: [],
            codigoSunat:'',
            listCodigoInterno: false,
            fechaInicioTraslado:'',
            recibeVehiculoSecundario:[],
            recibeVehiculos_Secundario:[
                { key: "numeroPlacaVehiculo", label:"Placa"},
                { key: "numeroCirculacionVehiculo", label:"Circulación"},
                { key: "nomEntidadEmisora", label:"Nombre Entidad"},
                { key: "codEntidadEmisora", label:"Codigo Entidad"},
                { key: "numeroAutorizacionVehiculo", label:"Nro. Autorización"},
                { key: "acciones", label:"Editar / Eliminar"}
            ],
            recibeVehiculos_SecundarioPreEmision:[
                { key: "numeroPlacaVehiculo", label:"Placa"},
                { key: "numeroCirculacionVehiculo", label:"Circulación"},
                { key: "nomEntidadEmisora", label:"Nombre Entidad"},
                { key: "codEntidadEmisora", label:"Codigo Entidad"},
                { key: "numeroAutorizacionVehiculo", label:"Nro. Autorización"},
            ],
            recibeConductorSecundario:[],
            recibeConductor_Secundario:[
                { key: "tipoConductor", label:"Tipo Conductor"},
                { key: "tipoDocumentoConductor", label:"Tipo Documento"},
                { key: "numeroDocumentoConductor", label:"Documento"},
                { key: "nombresConductor", label:"Nombre"},
                { key: "apellidosConductor", label:"Apellido"},
                { key: "numeroLicenciaConductor", label:"Licencia"},
                { key: "acciones", label:"Editar / Eliminar"}
            ],
            recibeConductor_SecundarioPreEmision:[
                { key: "tipoConductor", label:"Tipo Conductor"},
                { key: "tipoDocumentoConductor", label:"Tipo Documento"},
                { key: "numeroDocumentoConductor", label:"Documento"},
                { key: "nombresConductor", label:"Nombre"},
                { key: "apellidosConductor", label:"Apellido"},
                { key: "numeroLicenciaConductor", label:"Licencia"},
            ],
            guiaTransportista:{
                token:'',
                tipoDocumentoGuia:'',
                pesoBrutoTotal:'',
                unidadPesoBruto:'',
                fechaInicioTraslado:'',
                ubigeoPartida:'',
                direccionPartida:'',
                ubigeoLlegada:'',
                direccionLlegada:'',
                serie:'',
                receptor:{
                    tipo:'',
                    nro:'',
                },
                adicional:{
                    remitente:{
                        tipo:'',
                        nro:'',
                        razonSocial:'',
                    },
                    vehiculoPrincipal:{
                        numeroPlacaVehiculo:'',
                        numeroCirculacionVehiculo:'',
                        codEntidadEmisora:'',
                        numeroAutorizacionVehiculo:'',
                    },
                    datosMtc:{
                        nro:''
                    },
                    datosTraslado:{},
                    empresaSubcontrata:{},
                    tercero:{},

                    // vehiculosSecundario:[],
                    conductores:[]
                }
            },
            indexVehiculoSecundario:-1,
            indexConductor:-1,
            indexItem:-1,
            botonEditar:false,
            botonEditarConductor:false,
            bloquearCampoVehiSecundario: false,
            bloquearCampoConductor: false,
            mostrarEdit:false,
            valuePlaca:'',
            regexPlaca:'',
            autorizacionTransporte:'',
            numDocRelacionado:'',
            copiarDocRemitente:false,
            serieNumero:'',
            descripcionDoc:'',
            contador:0,
            contadorObservaciones:0,
            reciveDocRelacion:[],
            reciveDocRelacion_lista:[
                { key: "ruc", label:"Documento"},
                { key: "numero", label:"Número"},
                { key: "codigo", label:"Tipo Documento"},
                { key: "descripcionDoc", label:"Descripción"},
                { key: "acciones", label:"Eliminar"}
            ],
            reciveDocRelacion_listaPreEmision:[
                { key: "ruc", label:"Documento"},
                { key: "numero", label:"Serie-Numero"},
                { key: "codigo", label:"Tipo Documento"},
                { key: "descripcionDoc", label:"Descripción"},
            ],
            conductoresAsociados:[],
            listaConductorAsociado:false,
            idDocumentPreview: 0,
            tipoDocPreview: 0,
            postEmision: false,
            indicarTrasladoTotalBienes:false,
            indicadorRetornoVehiculoEnvases:false,
            indicadorRetornoVehiculoVacio:false,
            indicadorTransbordoProgramado:false,
            indicadorTransporteSubcontratado:false,
            indicadorPagadorFlete:0,
            indicadorPagadorFleteNombre:"",
            optionsIndicador:[
                { value: 0, text: 'Seleccione indicador de pagador de flete' },
                { value: 1, text: 'Remitente' },
                { value: 2, text: 'Tercero' },
                { value: 3, text: 'Subcontratador' },
            ],
            nroFlete:'',
            razonSocialFlete:'',
            bloquearFlete:false,
            bloquearFleteRUC:false,
            tipoDocumentoFlete:6,
            listaRemitentesFlete: [],
            listaRemitenteFlete:false,
            listaTer:[],
            capturaDirecciones:[],
            capturaDireccionesLlegada:[],
            previaEmision:false,
            emitiendo:false,
            total: 0.0,
            desde: 0.0,
            hasta: 0.0,
            paginaActual: 1,
            limite:50,
            orden: "desc",
            observaciones:'',
            paginaActualSecund: 1,
            lote: '',
            peso: '',
            fvencimientoItem: '',
            adicionalesItemsGuia: false,
            modalError500:false,
            errorJson: null,
            listaDescription: [],
            cargandoDescription: false,
            cargandoInformacion:false,
            nuevaBusqueda:false,
            opcionesOrdenadas: [], // Inicialmente vacío
            femision: '',
            currentdate: '',
            diasnopermitidos: {
                ranges: []
            },
        }
    },
    mounted(){
        this.infoSunat()
        this.getSeries() //Obtiene las series
        this.searchDepartmentOrigen() //ubigeo Origen
        this.searchDepartmentLlegada() //ubigeo Llegada
        this.listarUbigeos()
        this.mostrarCodigoMtc()
        this.customFormatter()
        this.customFormatterEmisionGRT()
        this.listarTerceros()
        this.initDates()
        

    },
    computed:{
        stateCirculacionVehiculoPlaca () {
            let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.placaVehiculo.length == 0){

            } else if (this.placaVehiculo.length < 6)  {
                return false
            } else if(this.placaVehiculo.length == 7 ){
                return true
            }
        },
        invalidFeedbackCirculacionVehiculoPlaca() {
            // let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.placaVehiculo.length == 1) {
                return 'Ingresar mínimo 6 valores y máximo 7'
            } else {
                return 'Ingresar mínimo 6 valores y máximo 7'
            }
        },
        stateCirculacionVehiculoPlacaSecun () {
            let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.placaVehiculoSecundario.length == 0){

            } else if (this.placaVehiculoSecundario.length < 6)  {
                return false
            } else if(this.placaVehiculoSecundario.length == 7 ){
                return true
            }
        },
        invalidFeedbackCirculacionVehiculoPlacaSecun() {
            // let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.placaVehiculoSecundario.length == 1) {
                return 'Ingresar mínimo 6 valores'
            } else {
                return 'Ingresar mínimo 6 valores y máximo 7'
            }
        },
        stateCirculacionVehiculo () {
            let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.numCirculacionVehiculo.length == 0){

            } else if (this.numCirculacionVehiculo.length < 10)  {
                return false
            } else if(this.numCirculacionVehiculo.length == 40 ){
                return true
            }
        },
       invalidFeedbackCirculacionVehiculo() {
            // let expreg = new RegExp("^[-_ a-zA-ZÀ-ÿ\u00f1\u00d10-9\s]{1,250}$")
            if (this.numCirculacionVehiculo.length == 1) {
                return 'Ingresar mínimo 10 valores'
            } else {
                return 'Ingresar mínimo 10 valores '
            }
        },
        validFeedbackCirculacionVehiculo () {
        // return this.stateCirculacionMtc === true ? 'Perfecto' : ''
        },
    },
    watch:{
        indicadorPagadorFlete(){
            if(this.indicadorPagadorFlete == 0){
                this.nroFlete = "";
                this.razonSocialFlete = "";
            }else if(this.indicadorPagadorFlete == 1){
                this.indicadorPagadorFleteNombre = "remitente"
                this.bloquearFlete = true;
                this.bloquearFleteRUC = true;
                this.tipoDocumentoFlete = this.tipoDocumentoRemitente
                this.nroFlete = this.remitente.numero
                this.razonSocialFlete = this.remitente.razonSocial
            }else if(this.indicadorPagadorFlete == 2){
                this.indicadorPagadorFleteNombre = "tercero"
                this.bloquearFlete = false;
                this.bloquearFleteRUC = false;
            }else if(this.indicadorPagadorFlete == 3){
                this.indicadorPagadorFleteNombre = "subcontratador"
                this.bloquearFlete = false;
                this.bloquearFleteRUC = true;
            }
        },
        pesoBrutoTotal(){
            if(this.pesoBrutoTotal.charAt(0) == "0"){
                setTimeout(() => this.pesoBrutoTotal = '', 100);   
            }
            
        },
        placaVehiculo(){
           if(this.placaVehiculo == ''){
                this.conductoresAsociados = []
           } 
        },
        listaRemitentes: function() {
            if (
                    this.listaRemitentes.length == 1 &&
                    this.remitente.numero.length == 11
            ) {
            this.setReceiverRemitente(this.listaRemitentes[0]);
            }  
        },
        listaReceptores: function() {
            if (
                    this.listaReceptores.length == 1 &&
                    this.receptor.numero.length == 11
            ) {
            this.setReceiver(this.listaReceptores[0]);
            }  
        },
        "remitente.numero"(){
            if(this.remitente.numero.length == 8){
                this.tipoDocumentoRemitente = 1
            }else if(this.remitente.numero.length == 11){
                this.tipoDocumentoRemitente = 6
            }
            if(this.remitente.numero.length < 2){
                this.remitente.razonSocial = '';
                this.remitente.direccion = '';
                this.listarUbigeos();
            }
            if(this.remitente.numero.length > 3){
                this.copiarDocRemitente = true;
            }else{
                this.copiarDocRemitente = false;
            }
        },
        "receptor.numero"(){
            if(this.receptor.numero.length == 8){
                this.tipoDocumento = 1
            }else if(this.receptor.numero.length == 11){
                this.tipoDocumento = 6
            }
            if(this.receptor.numero.length < 2){
                this.receptor.razonSocial = '';
                this.receptor.direccion = '';
            }
        },
        numDoc(){
             if(this.numDoc.length == 8){
                this.tipoDocConductor = 1
            }else if(this.numDoc.length == 11){
                this.tipoDocConductor = 6
            }
            if(this.numDoc.length < 2){
                this.nombreConductor = '';
                this.apellidoConductor = '';
                this.numLicencia = '';
            }
            if(this.tipoDocConductor == 6){
                if(this.numDoc.charAt(0) == "2"){
                   setTimeout(() => this.numDoc = '', 200);   
                }
            }
        },
        departamentoSeleccionadoUbigeoOrigen(){
            this.provOrigen = true;
            this.searchProvinceOrigen()
        },
        provinciaSeleccionadaUbigeoOrigen(){
            this.distOrigen = true,
            this.searchDistrictOrigen()
        },
        distritoSeleccionadoUbigeoOrigen(){
            this.ubigeoPartida = this.departamentoSeleccionadoUbigeoOrigen + 
                                 this.provinciaSeleccionadaUbigeoOrigen + 
                                 this.distritoSeleccionadoUbigeoOrigen,
            this.modalUbigeoPartida = false
        },
        direccionPartidaSelector(){
            if(this.listUbigeo[this.direccionPartidaSelector].ubigeo){
                this.ubigeoPartida = this.listUbigeo[this.direccionPartidaSelector].ubigeo
            }
            this.direccionPartidaTexto = this.listUbigeo[this.direccionPartidaSelector].direccion
        },
        // -------------------
        departamentoSeleccionadoUbigeoLlegada(){
            this.provLlegada = true;
            this.searchProvinceLlegada()
        },
        provinciaSeleccionadaUbigeoLlegada(){
            this.distLlegada = true,
            this.searchDistrictLlegada()
        },
        distritoSeleccionadoUbigeoLlegada(){
            this.ubigeoLlegada = this.departamentoSeleccionadoUbigeoLlegada + 
                                 this.provinciaSeleccionadaUbigeoLlegada + 
                                 this.distritoSeleccionadoUbigeoLlegada,
            this.modalUbigeoLlegada = false
        },
        direccionLlegadaSelector(){
            if(this.capturaDireccionesLlegada[this.direccionLlegadaSelector].ubigeo){
                this.ubigeoLlegada = this.capturaDireccionesLlegada[this.direccionLlegadaSelector].ubigeo
            }
            this.direccionLlegadaTexto = this.capturaDireccionesLlegada[this.direccionLlegadaSelector].direccion
        },
        descripcion: function() {
            if(this.descripcion.length > 500) {
            this.checkdescripcion = true;
            this.responsecheckdescripcion =
            "Alfanumerico de maximo 500 caracteres ";
            }else if (this.descripcion.length == 0) {
            (this.sinresultados = false),
            (this.listades = false),
            (this.listaDescription = []);
            }else {
            this.checkdescripcion = false;
            this.responsecheckdescripcion = "";
            this.sinresultados = false
            }
        },
    },
    methods:{
        pitcherReceiver: function(value) {
            if (value === 1) {
                if (this.receptor.numero.length >= 3) {
                    setTimeout(() => this.getReceivers(), 200);
                } else if (this.receptor.numero.length <= 2) {
                    this.initReceptor();
                }
            }
            // if (value === 2) {
            //     if (this.receptor.razonSocial.length >= 3) {
            //         setTimeout(() => this.getReceiversByRSocial(), 200);
            //     }else if (this.receptor.razonSocial.length <= 2) {
            //         this.initReceptor();
            //     }
            // }
        },
        //DESTINATARIO
        getReceivers: function () {
            this.buscandoReceptor = true;
            axios
            .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros',{
                token: this.$store.getters.userToken,
                q: this.receptor.numero,
                tipoRec: this.tipoDocumento 
            })
            .then(response => (
                this.listaReceptores = response.data,
                this.listaReceptor = true, 
                this.buscandoReceptor = false,
                this.receivercountReceptor(this.listaReceptores.length)                    
            ))
            .catch(function (error){
                this.listaReceptor = false,
                console.log(error)
            })                 
        },
        receivercountReceptor: function (value){
            if(!value){
                setTimeout(() => this.searchDNIReceptor(),1000);       
            }
        },
        searchDNIReceptor(){
            axios
            .get(process.env.VUE_APP_API_URL +'v2/dni',{
                params:{
                    token: this.$store.getters.userToken,
                    dni: this.receptor.numero
                }
            })
            .then(response => (
                this.listadniReceptor = response.data,
                this.listaReceptor = true,
                this.receivedniReceptor(this.listadniReceptor)
            ))
            .catch(error => (
                this.listaReceptor = false
            ))    
            
        },
        receivedniReceptor: function (value){
            if(!value)
            {
                this.mostrardniReceptor = false
            }
            else
            {
                this.mostrardniReceptor = true,
                this.setReceiverdniReceptor(this.listadniReceptor)
            }
        },
        setReceiverdniReceptor(item){
            this.receptor.razonSocial = item.nombre
            this.mostrardniReceptor = false
            this.listaReceptor = false
            this.listaReceptores = []
            this.buscandoReceptor = false
        },
        initReceptor: function() {
            this.receptor = {
                numero: "",
                tipo: "",
                direccion: "",
                nombre: "",
                direccionReferencia: ""
                },
            this.listaReceptores = []
        },
        setReceiver: function (item) {
            this.receptor.numero = item.idReceptor
            this.receptor.razonSocial = item.razonSocial
            this.receptor.direccion = item.direccionReferencia
            this.direcciones = item.direcciones,

            // cerrando lista de documentos
            this.listaReceptor = false;
        },
        // muestra lista de direcciones
        changeDirection(){
            this.verDirecciones = true;
        },
        changeDirectionRemitente(){
            this.verDireccionesRemitente = true;
        },
        // nueva direccion y cierra la lista
        setDirection: function(value) {
            this.receptor.direccion = value.direccion;
            this.verDirecciones = false;
        },
        setDirectionRemitente: function(value) {
            this.remitente.direccion = value.direccion;
            this.verDireccionesRemitente = false;
        },
        pitcherReceiverRemitente: function(value) {
            if (value === 1) {
                if (this.remitente.numero.length >= 3) {
                    setTimeout(() => this.getReceiversRemitente(), 200);
                } else if (this.remitente.numero.length <= 2) {
                    this.initReceptor();
                }
            }
            // conductor
            if (value === 2) {
                if (this.numDoc.length >= 3) {
                    setTimeout(() => this.getReceiverConductor(), 200);
                }
            }
            //Vehiculos
            if (value === 3) {
                if (this.placaVehiculo.length >= 2) {
                    setTimeout(() => this.getReceiverVehiculos(), 200);
                }
            }
            if (value === 4) {
                if (this.nroFlete.length >= 2) {
                    setTimeout(() => this.getReceiversRemitenteFlete(), 200);
                }
            }
        },
        getReceiverEntidadEmisora(){
            axios
            .post(process.env.VUE_APP_API_URL + 'entidadpermisos/buscar',{
                token: this.$store.getters.userToken,
                p: this.codEntidadEmisora,
            })
            .then(response => (
                this.listaEntidades = response.data,
                this.listaEntidad = true                   
            ))
            .catch(function (error){
                this.listaEntidad = false,
                console.log(error)         
            }) 
        },
        listaDeVehiculos(){  
            axios.post(process.env.VUE_APP_API_URL + "vehiculos/listar",{
                token:this.$store.getters.userToken,
                page: this.paginaActual,
                limit: this.limite,
                order: this.orden
            })
            .then(response =>(
                this.listaVehiculos = response.data.data,
                this.listaVehiculo = true,
                this.sinDatos(response.data.data),
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to
            ))
            .catch(error=>(
                console.log('ERROR LISTA INFORMACION',error.response.data)
            ))
        },
        paginaAnterior() {
            if (this.paginaActual > 1) {
                this.paginaActual--;
                this.listaDeVehiculos();
            }
            if (this.paginaActual > 1) {
                this.paginaActual--;
                this.listaDeVehiculos();
            }
        },
        paginaSiguiente() {
            if (this.paginaActual * this.limite < this.total) {
                this.paginaActual++;
                this.listaDeVehiculos();
            }
            if (this.paginaActual * this.limite < this.total) {
                this.paginaActual++;
                this.listaDeVehiculos();
            }
        },
        paginaAnteriorSec() {
            if (this.paginaActualSecund > 1) {
                this.paginaActualSecund--;
                this.listaDeVehiculosSecundarios();
            }
            if (this.paginaActualSecund > 1) {
                this.paginaActualSecund--;
                this.listaDeVehiculosSecundarios();
            }
        },
        paginaSiguienteSec() {
            if (this.paginaActualSecund * this.limite < this.total) {
                this.paginaActualSecund++;
                this.listaDeVehiculosSecundarios();
            }
            if (this.paginaActualSecund * this.limite < this.total) {
                this.paginaActualSecund++;
                this.listaDeVehiculosSecundarios();
            }
        },
        listaDeVehiculosSecundarios(){  
            axios.post(process.env.VUE_APP_API_URL + "vehiculos/listar",{
                token:this.$store.getters.userToken,
                page: this.paginaActualSecund,
                limit: this.limite,
                order: this.orden
            })
            .then(response =>(
                this.listaVehiculosSecundarios = response.data.data,
                this.listaVehiculoSecundario = true,
                this.sinDatos(response.data.data),
                this.total = response.data.total,
                this.desde = response.data.from,
                this.hasta = response.data.to
            ))
            .catch(error=>(
                console.log('ERROR LISTA INFORMACION',error.response.data)
            ))
        },
        getReceiverVehiculosSecundarios(){
            axios
            .post(process.env.VUE_APP_API_URL + 'vehiculos/buscar',{
                token: this.$store.getters.userToken,
                p: this.placaVehiculo,
            })
            .then(response => (
                this.listaVehiculosSecundarios = response.data,
                this.listaVehiculoSecundario = true,
                this.sinDatos(response.data)  
            ))
            .catch(function (error){
                this.listaVehiculo = false,
                console.log(error)
            }) 
        },
        getReceiverVehiculos(){
            axios
            .post(process.env.VUE_APP_API_URL + 'vehiculos/buscar',{
                token: this.$store.getters.userToken,
                p: this.placaVehiculo,
            })
            .then(response => (
                this.listaVehiculos = response.data,
                this.listaVehiculo = true,
                this.sinDatos(response.data)  
            ))
            .catch(function (error){
                this.listaVehiculo = false,
                console.log(error)
            }) 
        },
        sinDatos(value){
            if(value.length == 0){
                this.$snotify.warning('Información no registrada','Ups!')
            }
        },
        getReceiverConductor(){
            axios
            .post(process.env.VUE_APP_API_URL + 'conductor/buscar',{
                token: this.$store.getters.userToken,
                p: this.numDoc,
            })
            .then(response => (
                this.listaConductores = response.data,
                this.listaConductor = true,
                this.sinDatos(response.data)                       
            ))
            .catch(function (error){
                this.listaConductor = false,
                console.log(error)
            }) 
        },
        getReceiverConductorNombre(){
            axios
            .post(process.env.VUE_APP_API_URL + 'conductor/buscar',{
                token: this.$store.getters.userToken,
                p: this.nombreConductor,
            })
            .then(response => (
                this.listaConductores = response.data,
                this.listaConductor = true,
                this.sinDatos(response.data)                         
            ))
            .catch(function (error){
                this.listaConductor = false,
                console.log(error)
            }) 
        },
        listarConductores(){
            this.listaConductorAsociado = false,
            axios
            .post(process.env.VUE_APP_API_URL + 'conductor/listar',{
                token: this.$store.getters.userToken,
                p: this.numDoc,
            })
            .then(response => (
                this.listaConductores = response.data.data,
                this.listaConductor = true,
                this.sinDatos(response.data.data)                      
            ))
            .catch(function (error){
                this.listaConductor = false,
                console.log(error)
            }) 
        },
        //REMITENTE
        getReceiversRemitente: function () {
            this.buscandoRemitente = true,
            axios
            .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros',{
                token: this.$store.getters.userToken,
                q: this.remitente.numero,
                tipoRec: this.tipoDocumentoRemitente 
            })
            .then(response => (
                this.listaRemitentes = response.data,
                this.listaRemitente = true,
                this.buscandoRemitente = false,
                this.receivercount(this.listaRemitentes.length)                        
            ))
            .catch(function (error){
                this.listaRemitente = false,
                console.log(error)
            })                 
        },
        receivercount: function (value){
            if(!value){
                setTimeout(() => this.searchDNIRemitente(),1000);       
            }
        },
        searchDNIRemitente(){
            axios
            .get(process.env.VUE_APP_API_URL +'v2/dni',{
                params:{
                    token: this.$store.getters.userToken,
                    dni: this.remitente.numero
                }
            })
            .then(response => (
                this.listadni = response.data,
                this.listaRemitente = true,
                this.receivedniRemitente(this.listadni)
            ))
            .catch(error => (
                this.listaRemitente = false
            ))    
            
        },
        receivedniRemitente: function (value){
            if(!value)
            {
                this.mostrardniRemitente = false
            }
            else
            {   
                this.mostrardniRemitente = true,
                this.setReceiverdniRemitente(this.listadni)
            }
        },
        setReceiverdniRemitente(item){
            this.remitente.razonSocial = item.nombre
            this.mostrardniRemitente = false
            this.listaRemitente = false
            this.listaRemitentes = []
            this.buscandoRemitente = false
        },
        getReceiversRemitenteFlete: function () {
            axios
            .post(process.env.VUE_APP_API_URL + 'receptores/listaconterceros',{
                token: this.$store.getters.userToken,
                q: this.nroFlete,
                tipoRec: this.tipoDocumentoFlete 
            })
            .then(response => (
                this.listaRemitentesFlete = response.data,
                this.listaRemitenteFlete = true                         
            ))
            .catch(function (error){
                this.listaRemitenteFlete = false,
                console.log(error)
            })                 
        },
        initRemitente: function() {
            this.remitente = {
                numero: "",
                tipo: "",
                direccion: "",
                nombre: "",
                direccionReferencia: ""
                },
            this.listaRemitente = []
        },
        setReceiverRemitente: function (item) {
            this.remitente.numero = item.idReceptor
            this.remitente.razonSocial = item.razonSocial
            this.remitente.direccion = item.direccionReferencia
            this.direcciones = item.direcciones,

            // cerrando lista de documentos
            this.listaRemitente = false,
            this.listarUbigeos()
            
        },
        setReceiverRemitenteFlete: function (item) {
            this.nroFlete = item.idReceptor
            this.razonSocialFlete = item.razonSocial
            // cerrando lista de documentos
            this.listaRemitenteFlete = false;
        },
        setReceiverConductor: function (item) {
        this.numDoc = item.nroDocumento,
        this.nombreConductor = item.nombres.toUpperCase();
        this.apellidoConductor = item.apellidos.toUpperCase();
        this.numLicencia = item.nroLicencia.toUpperCase();

        // cerrando lista de documentos
        this.listaConductor = false;
        },
        setReceiverVehiculo: function (item) {
            if(item.driver.length > 0){
                this.conductoresAsociados = item.driver
                this.numDoc = item.driver[0].nroDocumento,
                this.nombreConductor = item.driver[0].nombres,
                this.apellidoConductor = item.driver[0].apellidos,
                this.numLicencia = item.driver[0].nroLicencia
            }
            this.placaVehiculo = item.placa,
            this.numCirculacionVehiculo = item.nroCirculacionMTC,
            // this.pesoBrutoTotal = item.pesoBruto,
            this.codEntidadEmisora = item.idEntidad,
            this.numAutorizacionVehiculo = item.numeroPermiso
            // cerrando lista de documentos
            this.listaVehiculo = false;
        },
        setReceiverVehiculoSecundario: function (item) {
            this.placaVehiculoSecundario = item.placa,
            this.numCirculacionVehiculoSecundario = item.nroCirculacionMTC,
            this.codEntidadEmisoraSecundario = item.idEntidad,
            this.numAutorizacionVehiculoSecundario = item.numeroPermiso
            // cerrando lista de documentos
            this.listaVehiculoSecundario = false;
        },
        setReceiverEntidad: function (item) {
            this.codEntidadEmisora = item.codigo,
            this.numAutorizacionVehiculo = item.numeroPermiso
            // cerrando lista de documentos
            this.listaEntidad = false;
        },
        // Series
        getSeries: function () {
            axios
            .post(process.env.VUE_APP_API_URL + 'usuario/series/13', {
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.listaSeries = response.data.data
                ))
            .catch(error => {
                console.log('Error de Series =>',error)
            })
        },
        // ubigeoOrigen
        searchDepartmentOrigen: function () {
            axios
            .post(process.env.VUE_APP_API_URL + 'ubigeo/departamento',{
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.listDepartamento = response.data.Departments               
            ))
            .catch(error => {
                console.log(error)
            })
        },
        searchProvinceOrigen: function () {
            this.provOrigenCargando = true
             axios
            .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
                token: this.$store.getters.userToken,
                department: this.departamentoSeleccionadoUbigeoOrigen
            })
            .then(response => (
                this.provOrigenCargando = false,
                this.listProvinceOrigen = response.data.Departments                      
            ))
            .catch(error => {})
        },
        searchDistrictOrigen: function () {
            this.distOrigenCargando = true;
            axios
            .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
                token: this.$store.getters.userToken,
                department: this.departamentoSeleccionadoUbigeoOrigen,
                province: this.provinciaSeleccionadaUbigeoOrigen
            })
            .then(response => (
                this.distOrigenCargando = false,
                this.listDistrictOrigen = response.data.Departments,
                this.ubigeoPartida = this.departamentoSeleccionadoUbigeoOrigen + 
                                     this.provinciaSeleccionadaUbigeoOrigen + 
                                     this.distritoSeleccionadoUbigeoOrigen   
            ))
            .catch(error => {})
        },
        cambiarASelecctorDireccion(value) {
             if(value == 1){
                this.mostrarubigeoTexto = false;
                this.listarUbigeos();
             }else{
                this.mostrarubigeoTexto = true 
            }       
        },
        cambiarASelecctorDireccionLlegada(value) {
             if(value == 1){
                this.mostrarubigeoTextoLlegada = false;
                if(this.receptor.numero.length == 11){
                    this.filtrarDocumentoLlegada();
                }
             }else{
                this.mostrarubigeoTextoLlegada = true;
             }      
        },
        listarUbigeos(){
        axios
            .post(process.env.VUE_APP_API_URL + "establecimientos/listar", {
                token: this.$store.getters.userToken
            })
            .then(
            response => (
                this.listUbigeo = response.data.data,
                this.direciconInicialUbi()
            ))
            .catch(error => (
                console.log('Error al listar establecimientos(Direcciones) =>',error)
            ));

            if(this.remitente.numero.length == 11){
                this.filtrarDocumento();
            }
        },
        direciconInicialUbi(){  
            this.direccionPartidaSelector = 0
            if(this.listUbigeo[0].ubigeo){
                this.ubigeoPartida = this.listUbigeo[0].ubigeo
            }
        },
        // ubigeo Llegada
        searchDepartmentLlegada: function () {
            axios
            .post(process.env.VUE_APP_API_URL + 'ubigeo/departamento',{
                token: this.$store.getters.userToken
            })
            .then(response => (
                this.listDepartamentoLlegada = response.data.Departments               
            ))
            .catch(error => {
                console.log(error)
            })
        },
        searchProvinceLlegada: function () {
            this.provLlegadaCargando = true
             axios
            .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
                token: this.$store.getters.userToken,
                department: this.departamentoSeleccionadoUbigeoLlegada
            })
            .then(response => (
                this.provLlegadaCargando = false,
                this.listProvinceLlegada = response.data.Departments                      
            ))
            .catch(error => {})
        },
        searchDistrictLlegada: function () {
            this.distLlegadaCargando = true;
            axios
            .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
                token: this.$store.getters.userToken,
                department: this.departamentoSeleccionadoUbigeoLlegada,
                province: this.provinciaSeleccionadaUbigeoLlegada
            })
            .then(response => (
                this.distLlegadaCargando = false,
                this.listDistrictLlegada = response.data.Departments,
                this.ubigeoLlegada = this.departamentoSeleccionadoUbigeoLlegada + 
                                     this.provinciaSeleccionadaUbigeoLlegada + 
                                     this.distritoSeleccionadoUbigeoLlegada   
            ))
            .catch(error => {
                console.log(error)
            })
        },
        guardarVehiculoSecundario(){
            let vehiculosSecundario ={}
                vehiculosSecundario.numeroPlacaVehiculo = this.placaVehiculoSecundario;
                vehiculosSecundario.numeroCirculacionVehiculo = this.numCirculacionVehiculoSecundario ;
                vehiculosSecundario.nomEntidadEmisora = this.infoEntidadEmisora[this.codEntidadEmisoraSecundario].nombre; //borrar al enviar
                vehiculosSecundario.codEntidadEmisora = this.infoEntidadEmisora[this.codEntidadEmisoraSecundario].codigo;
                vehiculosSecundario.codEdicion = this.codEntidadEmisoraSecundario; //borrar al enviar
                vehiculosSecundario.numeroAutorizacionVehiculo = this.numAutorizacionVehiculoSecundario;          
            if(this.indexVehiculoSecundario != -1){
                Object.assign(this.recibeVehiculoSecundario[this.indexVehiculoSecundario], vehiculosSecundario)
                this.indexVehiculoSecundario = -1
                this.botonEditar = false;
            }else{
                this.recibeVehiculoSecundario.push(vehiculosSecundario);

            }
            this.placaVehiculoSecundario = '';
            this.numCirculacionVehiculoSecundario = '';
            this.codEntidadEmisoraSecundario = 0;
            this.numAutorizacionVehiculoSecundario = '';
            if(this.recibeVehiculoSecundario.length >= 2){
                this.bloquearCampoVehiSecundario = true;
            }
        },
        validarCamposVehiculo(){
            if(this.placaVehiculoSecundario.length > 5 && this.numCirculacionVehiculoSecundario !=''){
                return true;
            }else{
                return false;
            }
        },
        editarVehiculoSecundario(index, item){
           this.indexVehiculoSecundario = index;
           this.placaVehiculoSecundario = item.numeroPlacaVehiculo;
           this.numCirculacionVehiculoSecundario = item.numeroCirculacionVehiculo;
           this.codEntidadEmisoraSecundario = item.codEdicion;
           this.numAutorizacionVehiculoSecundario = item.numeroAutorizacionVehiculo
           this.botonEditar = true;
           this.bloquearCampoVehiSecundario = false;
        },
        editarVehiculo(){     
            this.guardarVehiculoSecundario()
        },
        eliminarVehiculoSecundario(index){
            this.recibeVehiculoSecundario.splice(index,1)
            if(this.recibeVehiculoSecundario.length >= 2){
                this.bloquearCampoVehiSecundario = true;
            }else{
                this.bloquearCampoVehiSecundario = false;
            }
        },
        guardarConductor(){
            let conductor = {}
                if(this.recibeConductorSecundario.length == 0 || this.indexConductor == 0){
                    conductor.tipoConductor = 'Principal'
                }else{
                    conductor.tipoConductor = 'Secundario'
                }
                conductor.tipoDocumentoConductor = this.tipoDocConductor;
                conductor.numeroDocumentoConductor = this.numDoc;
                conductor.nombresConductor = this.nombreConductor;
                conductor.apellidosConductor = this.apellidoConductor;
                conductor.numeroLicenciaConductor = this.numLicencia;
            if(this.indexConductor != -1){
                Object.assign(this.recibeConductorSecundario[this.indexConductor], conductor)
                this.indexConductor = -1
                this.botonEditarConductor = false;
            }else{
                this.recibeConductorSecundario.push(conductor);
            }
            this.tipoDocConductor = '6';
            this.numDoc = '';
            this.nombreConductor = '';
            this.apellidoConductor = '';
            this.numLicencia = '';
            if(this.recibeConductorSecundario.length >= 3){
                this.bloquearCampoConductor = true;
            }
        },
        validarConductor(){
            if(this.numDoc !='' && 
                this.nombreConductor !='' &&
                this.apellidoConductor !='' &&
                this.apellidoConductor !='' &&
                this.numLicencia !=''){
                return true;
            }else{
                return false;
            }
        },
        editarConductor(){     
            this.guardarConductor()
        },
        editarDatosConductor(index, item){
           this.indexConductor = index;
           this.tipoDocConductor = item.tipoDocumentoConductor
           this.numDoc = item.numeroDocumentoConductor;
           this.nombreConductor = item.nombresConductor;
           this.apellidoConductor = item.apellidosConductor;
           this.numLicencia = item.numeroLicenciaConductor;
           this.botonEditarConductor = true;
           this.bloquearCampoConductor = false;
        },
        eliminarConductor(index){
            this.recibeConductorSecundario.splice(index,1)
            if(this.recibeConductorSecundario.length >= 2){
                this.bloquearCampoConductor = true;
            }else{
                this.bloquearCampoConductor = false;
            }
        },
        customFormatter(date) {
            this.fechaInicioTraslado = this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
            return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
        customFormatterEmisionGRT(date){
            this.femision = this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
            return this.$moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
        tecla(event){
        //  this.lastKeyPressed = event.key;
            if (event.keyCode === 13) {
            this.getReceiversDescription();
            return;
            }
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {this.getReceiversDescription();}, 1000)
        },
        getReceiversDescription: function() {
        let arrayNuevo = []
            this.listaDescription = []
            if(this.descripcion.length >=3){
                arrayNuevo = this.$store.getters.getTotalItems.filter(item => {
                // Verificar si la descripción del producto contiene el texto de búsqueda
                if(item && item.descripcion){
                  return item.descripcion.toLowerCase().includes(this.descripcion.toLowerCase());
                }
                });
                this.sinresultados = true, 
                this.cargandoDescription = true,
                this.listades = true,
                this.nodescription = false,

                this.listaDescription = arrayNuevo,
                this.cargandoDescription = false,
                this.sinresultados = false,
                this.cargandoreceptor = false,
                this.receivercountDescription(this.listaDescription.length),
                this.ordenarOpciones(this.listaDescription)
            }else{
                arrayNuevo = []
            }
            if (arrayNuevo.length === 0 && this.descripcion.length >= 4) {
                this.$snotify.warning('PRODUCTO NO ENCONTRADO')
            } 
        },
        ordenarOpciones: function(item) {
            this.opcionesOrdenadas = item.slice().sort((a, b) => {
                const lowerCaseDescripcionA = a.descripcion.toLowerCase();
                const lowerCaseDescripcionB = b.descripcion.toLowerCase();
                const lowerCaseSearch = this.descripcion.toLowerCase();

                const indexA = lowerCaseDescripcionA.indexOf(lowerCaseSearch);
                const indexB = lowerCaseDescripcionB.indexOf(lowerCaseSearch);
                // Si ambos tienen la misma cantidad de caracteres coincidentes,
                // ordenar por el índice en la descripción
                if (indexA === indexB) {
                    return indexA - indexB;
                }
                // Si tienen diferentes cantidades de caracteres coincidentes,
                // ordenar por la diferencia en la cantidad de caracteres
                if (indexA === 0) {
                    return -1; // a aparece primero
                } else if (indexB === 0) {
                    return 1; // b aparece primero
                } else if (indexA > 0 && indexB > 0) {
                    // Si ambos están después de la primera posición,
                    // ordenar por la posición
                    return indexA - indexB;
                } else {
                    // Si uno de ellos no contiene el término de búsqueda en la descripción,
                    // el que contiene la coincidencia aparece primero
                    return indexA < 0 ? 1 : -1;
                }
            });
        },
        cerrarresultados: function() {
            (this.listaDescription = []), (this.listades = false);
        },
        receivercountDescription: function(value) {
            if (!value) {
            this.nodescription = true;
            } else {
            this.nodescription = false;
            }
        },
        searchDescripcion(){
            if(this.descripcion.length > 2){
                this.listades = true,
                axios
                .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                    token: this.$store.getters.userToken,
                    filtro: 'name',
                    p: this.descripcion
                })
                .then(response=>(
                    this.listProductos = response.data.response
                ))
                .catch(error=>(
                console.log(error)
                ))
            }       
        },
        // setReceiverDescription: function (item) {
        //     this.codigoItem = item.codigo,
        //     this.descripcion = item.descripcion,
        //     this.codigoBarras = item.codigoProductoGs1
        //     this.codigoSunat = item.codigoProductoSunat
        //     this.unidadMedidaCantidad = item.unidadMedida,
        //     this.listades = false,
        //     this.listProductos = []
        // },
        setReceiverDescription: function(item) {
            this.itemEditado = false,
            this.stock = item.stock,
            (this.idProducto = item.idProducto),
            (this.codigoItem = item.codigo),
            (this.descripcion = item.descripcion),
            (this.codigoSunat = item.codigoProductoSunat),
            (this.precioVentaUnitario = item.precioUnitario);
            this.unidadMedidaCantidad = item.unidadMedida;
            if (item.tipoAfectacionIgv == "") {
            this.especificacionIgv = "01";
            } else {
            this.especificacionIgv = item.tipoAfectacionIgv;
            }
            (this.listades = false), (this.listaDescription = []);
            if(item.isc !='' && item.isc != null){
            this.isc = true;
            this.selectedISC = item.isc.tipoISC;
            if(item.isc.tipoISC == 3){
                this.montoISC = item.isc.valorReferencial
                this.porcentajeISC = item.isc.valorISC
            }else{
                this.montoISC = item.isc.valorISC
            }
            }
        },
        agregarItem(item){
            this.setReceiverDescription(item)
        },
        getReceiversCodigoInterno: function () {
            if(this.codigoItem.length >=2){ 
                this.listCodigoInterno = true,
                axios
                .post(process.env.VUE_APP_API_URL + 'productos/buscar',{
                    token: this.$store.getters.userToken,   
                    filtro: 'code',
                    p: this.codigoItem
                })
                .then(response => (
                    this.listaCodigoInterno = response.data.response                               
                ))
                .catch(error => {
                    this.listCodigoInterno = false
                }) 
            }
        },
        setReceiverCodigoInterno: function (item) {
            this.cantidad = item.cantidad
            this.codigoItem = item.codigo,
            this.descripcion = item.descripcion,
            this.unidadMedidaCantidad = item.unidadMedida,
            this.listCodigoInterno = false,
            this.listaCodigoInterno = []
        },
        validarItems(){
            if(this.cantidad !='' && this.descripcion !=''){
                return false;
            }else{
                return true;
            }
        },
        addItems(){
            let items = {
                adicional: {}
            }
                items.cantidad = this.cantidad;
                items.unidadMedida = this.unidadMedidaCantidad;
                items.descripcion = this.descripcion;
                items.codItem = this.codigoItem;
                items.codSunat = this.codigoSunat;
            if(this.lote != '' || this.peso != ''){
                items.adicional.peso = this.peso
                items.adicional.lote = this.lote
            }else{
                delete items.adicional
            }
            if(this.indexItem != -1){
                Object.assign(this.productosLista[this.indexItem], items)
                this.indexItem = -1
            }else{
                this.productosLista.push(items);
            }
            this.mostrarEdit = false;
            this.cantidad = 1;
            this.unidadMedidaCantidad = 'NIU';
            this.descripcion = '';
            this.codigoItem = '';
            this.codigoSunat ='';
        },
        editarItems(index, item){
            this.indexItem = index;
            this.cantidad = item.cantidad;
            this.unidadMedidaCantidad = item.unidadMedida;
            this.descripcion = item.descripcion;
            this.codigoItem = item.codItem;
            this.codigoSunat = item.codSunat;
            this.mostrarEdit = true;
        },
        editarItemProducto(){
            this.addItems();
        },
        eliminarItems(index){
            this.productosLista.splice(index,1)
        },
        validarEnvioGuia(){
            if(this.receptor.numero !='' && 
                this.receptor.razonSocial !='' &&
                this.receptor.direccion !='' && 
                this.remitente.numero !='' &&
                this.remitente.razonSocial !='' &&
                this.remitente.direccion !='' &&
                this.direccionLlegadaTexto !='' &&
                this.ubigeoPartida !='' &&
                this.ubigeoLlegada !='' &&
                this.placaVehiculo !='' &&
                this.numCirculacionVehiculo !='' &&
                this.pesoBrutoTotal !='' &&
                this.fechaInicioTraslado !='' &&
                this.recibeConductorSecundario.length > 0 &&
                this.productosLista.length >0){
                    return false;
            }else{
                    return true;
            }
        },
        validaVistaPrevia(){
            this.previaEmision = true;
        },
        cerrarVistaPrevia(){
            this.previaEmision = false;
        },
        mostrarCodigoMtc(){
            axios
            .post(process.env.VUE_APP_API_URL + "guiaremitente/guiatransportista/index",{
                token:this.$store.getters.userToken
            })
            .then(response =>(
                this.autorizacionTransporte = response.data.data
            ))
            .catch(error=>(
                console.log('error autorizacion',error)
            ))
        },
        emitirGuiaTransportista(){
            this.emitiendo = true;
            this.guiaTransportista.token = this.$store.getters.userToken;
             if(this.serieInicial == 0){
                 this.guiaTransportista.serie = this.listaSeries[0]  
                }else{
                   this.guiaTransportista.serie = this.listaSeries[this.serieInicial]   
                } 
            this.guiaTransportista.tipoDocumentoGuia = this.tipoDocumentoGuia;
            this.guiaTransportista.pesoBrutoTotal = parseFloat(this.pesoBrutoTotal);
            this.guiaTransportista.unidadPesoBruto = "KGM"
            this.guiaTransportista.fechaInicioTraslado = this.fechaInicioTraslado
            this.guiaTransportista.ubigeoPartida = this.ubigeoPartida
            this.guiaTransportista.direccionPartida = this.mostrarubigeoTexto == true ? this.direccionPartidaTexto.substr(0,100) : this.listUbigeo[this.direccionPartidaSelector].direccion.substr(0,100);
            this.guiaTransportista.ubigeoLlegada = this.ubigeoLlegada;
            this.guiaTransportista.direccionLlegada = this.mostrarubigeoTextoLlegada == true ? this.direccionLlegadaTexto.substr(0,100) : this.capturaDireccionesLlegada[this.direccionLlegadaSelector].direccion.substr(0,100);
            this.guiaTransportista.receptor.tipo = this.tipoDocumento;
            this.guiaTransportista.receptor.nro = this.receptor.numero;
            this.guiaTransportista.receptor.direccion = this.receptor.direccion;
            this.guiaTransportista.receptor.razonSocial = this.receptor.razonSocial;
            this.guiaTransportista.adicional.dirAlternativa = this.receptor.direccion;
             if(this.reciveDocRelacion.length !=0){
                this.guiaTransportista.documentosRelacionados = this.reciveDocRelacion;
            }
            this.guiaTransportista.adicional.datosMtc.nro = this.autorizacionTransporte.numeroPermiso; 
            this.guiaTransportista.adicional.datosMtc.nroAutorizacion = this.autorizacionTransporte.autorizacionMtc; 
            this.guiaTransportista.adicional.datosMtc.codEntidadEmisora = this.autorizacionTransporte.idEntidad; 
            this.guiaTransportista.adicional.remitente.tipo = this.tipoDocumentoRemitente;
            this.guiaTransportista.adicional.remitente.nro = this.remitente.numero;
            this.guiaTransportista.adicional.remitente.razonSocial = this.remitente.razonSocial;
            this.guiaTransportista.adicional.remitente.direccion = this.remitente.direccion;
            this.guiaTransportista.adicional.vehiculoPrincipal.numeroPlacaVehiculo = this.placaVehiculo;
            this.guiaTransportista.adicional.vehiculoPrincipal.numeroCirculacionVehiculo = this.numCirculacionVehiculo;
            this.guiaTransportista.adicional.vehiculoPrincipal.codEntidadEmisora = this.infoEntidadEmisora[this.codEntidadEmisora].codigo,
            this.guiaTransportista.adicional.vehiculoPrincipal.numeroAutorizacionVehiculo = this.numAutorizacionVehiculo;
            if(this.recibeVehiculoSecundario.length !=0){
                this.recibeVehiculoSecundario.forEach(el => delete el.codEdicion)
                this.recibeVehiculoSecundario.forEach(el => delete el.nomEntidadEmisora)
                this.guiaTransportista.adicional.vehiculosSecundario = this.recibeVehiculoSecundario; 
            }
            this.guiaTransportista.adicional.datosTraslado.indicadorTrasladoTotalBienes = this.indicarTrasladoTotalBienes;
            this.guiaTransportista.adicional.datosTraslado.indicadorRetornoVehiculoEnvases = this.indicadorRetornoVehiculoEnvases;
            this.guiaTransportista.adicional.datosTraslado.indicadorRetornoVehiculoVacio = this.indicadorRetornoVehiculoVacio;
            this.guiaTransportista.adicional.datosTraslado.indicadorTransbordoProgramado = this.indicadorTransbordoProgramado;
            this.guiaTransportista.adicional.datosTraslado.indicadorTransporteSubcontratado = this.indicadorTransporteSubcontratado;
            this.guiaTransportista.adicional.datosTraslado.indicadorPagadorFlete = this.indicadorPagadorFleteNombre;
            if(this.indicadorPagadorFlete == 2){
                this.guiaTransportista.adicional.tercero.tipo = this.tipoDocumentoFlete;
                this.guiaTransportista.adicional.tercero.nro = this.nroFlete;
                this.guiaTransportista.adicional.tercero.razonSocial = this.razonSocialFlete;
            }else{
                delete this.guiaTransportista.adicional.tercero
            }
            if(this.indicadorPagadorFlete == 3){
                this.guiaTransportista.adicional.empresaSubcontrata.nro = this.nroFlete;
                this.guiaTransportista.adicional.empresaSubcontrata.razonSocial = this.razonSocialFlete;
            }else{
                delete this.guiaTransportista.adicional.empresaSubcontrata
            }
            if(this.femision != ''){
                if(this.$moment(this.femision).format('YYYY-MM-DD') == this.$moment(this.currentdate).format('YYYY-MM-DD')){
                     //si la fecha es == a hoy, no se envia fecha
                       delete this.guiaTransportista.fechaEmision;
                }else{
                    //si la fecha es diferente de hoy(fecha de ayer), se envia.
                    this.guiaTransportista.fechaEmision = this.$moment(this.femision).format('YYYY-MM-DD HH:mm:ss')
                }
            }
            this.guiaTransportista.adicional.observaciones = this.observaciones;
            this.guiaTransportista.adicional.conductores = this.recibeConductorSecundario;
            this.guiaTransportista.items = this.productosLista;
            axios
            .post(process.env.VUE_APP_API_URL + "guiaremitente/guiatransportista/emitir",this.guiaTransportista)
            .then(response=>(
                this.$snotify.success(response.data.msg, 'Éxito'),
                this.previaEmision = false,
                this.motrarPDF(response.data.response.idGuiaTransportista),
                this.clearGuiaTransportista()
            ))
            .catch(error=>{
                if (error.response && error.response.status === 500) {
                        this.modalError500 = true
                        this.errorJson = error.response.data;
                    }
                this.emitiendo = false,
                this.$snotify.danger(error.data.msg, 'Error')
                })
        },
        refreshPage() {
            this.$router.go(0); //recagar la pagina al incio
        },
        async copyJsonToClipboard() {
            try {
                await navigator.clipboard.writeText(JSON.stringify(this.errorJson));
                this.$snotify.success('JSON copiado al portapapeles', 'Éxito');
            } catch (err) {
                this.$snotify.error('No se pudo copiar el JSON al portapapeles', 'Error');
            }
        },
        motrarPDF(id){
            if(id != 0){
                this.idDocumentPreview = id
                this.tipoDocPreview = 6
                this.postEmision = true
            }
        },
        clearGuiaTransportista(){
            this.emitiendo = false,
            this.bloquearFleteRUC = false,
            this.pesoBrutoTotal = "",
            this.indicarTrasladoTotalBienes = false,
            this.indicadorRetornoVehiculoEnvases = false,
            this.indicadorRetornoVehiculoVacio = false,
            this.indicadorTransbordoProgramado = false,
            this.indicadorTransporteSubcontratado = false,
            this.indicadorPagadorFlete = 0
            this.indicadorPagadorFleteNombre = "",
            this.remitente.numero = '',
            this.remitente.razonSocial = '',
            this.remitente.direccion = '',
            this.receptor.numero = '',
            this.receptor.razonSocial = '',
            this.receptor.direccion = '',
            // this.ubigeoPartida = '',
            this.ubigeoLlegada = '',
            // this.direccionPartidaTexto = '',
            this.direccionLlegadaTexto = '',
            this.placaVehiculo = '',
            this.numCirculacionVehiculo = '',
            this.codEntidadEmisora = 0
            this.numAutorizacionVehiculo = '',
            this.recibeVehiculoSecundario = [],
            this.recibeConductorSecundario = [],
            this.fechaInicioTraslado = this.customFormatter(),
            this.productosLista = [],
            this.reciveDocRelacion = [],
            this.conductoresAsociados = [],
            this.bloquearCampoConductor = false,
            this.bloquearCampoVehiSecundario = false,
            this.femision = '',
            this.initDates()
        },
        mayus(){
            this.placaVehiculo = this.placaVehiculo.toUpperCase();
            this.placaVehiculoSecundario = this.placaVehiculoSecundario.toUpperCase();   
            this.serieNumero = this.serieNumero.toUpperCase();
            this.nombreConductor = this.nombreConductor.toUpperCase();
            this.apellidoConductor = this.apellidoConductor.toUpperCase();
            this.numLicencia = this.numLicencia.toUpperCase();
        },  
        closeListVehiculo(){
            this.listaVehiculo = false;
        },
        closeListVehiculoSecundario(){
            this.listaVehiculoSecundario = false;
        },
        closeListEntidad(){
            this.listaEntidad = false;
        },
        closeListConductor(){
            this.listaConductor = false;
        },
        copiarDoc(){
            this.numDocRelacionado = this.remitente.numero
        },
        contadorCaracteres(value){
            if(value == 1){
                this.contador = this.descripcionDoc.length;
            }else if(value == 2){
                this.contadorObservaciones = this.observaciones.length;
            }
            
        },
        cerraListaProductos(){
            this.listades = false;
        },
        validarAddDoc(){
            if(this.numDocRelacionado !='' &&
                this.serieNumero !='' &&
                this.docRelacionado !=''){
                return false
            }else{
                return true
            }
        },
        addDocRelacion(){
            let docRelacion = {}
            docRelacion.ruc = this.numDocRelacionado,
            docRelacion.numero = this.serieNumero,
            docRelacion.codigo = this.docRelacionado,
            docRelacion.descripcionDoc = this.descripcionDoc
            this.reciveDocRelacion.push(docRelacion)
            this.numDocRelacionado = '',
            this.serieNumero = '',
            this.docRelacionado = 0,
            this.descripcionDoc = '',
            this.contador = 0
            this.$snotify.success("Documento relacionado fue agregado","Éxito")
        },
        eliminarDocRelacion(index){
            this.reciveDocRelacion.splice(index,1)
        },
        closeListConductorAsociado(){
            this.listaConductorAsociado = false
        },
        seleccionarConductorAsociado(){
            this.listaConductorAsociado = true,
            this.listaConductor = false
        },
        setReceiverConductorAsociado(item){
            this.numDoc = item.nroDocumento,
            this.nombreConductor = item.nombres.toUpperCase();
            this.apellidoConductor = item.apellidos.toUpperCase();
            this.numLicencia = item.nroLicencia.toUpperCase();
            this.listaConductorAsociado = false
        },
        limpiarTextoPegado(event) {
            event.preventDefault(); // Evita el pegado directo sin filtrar
            let texto = (event.clipboardData || window.clipboardData).getData("text"); 
            // Elimina los caracteres no permitidos (ej. "-")
            texto = texto.replace(/[^a-zA-Z0-9]/g, "");  
            // Asigna el texto limpio a la variable vinculada con v-model
                this.placaVehiculo = texto
        },
        limpiarTextoPegadoSecundario(event) {
            event.preventDefault(); // Evita el pegado directo sin filtrar
            let texto = (event.clipboardData || window.clipboardData).getData("text"); 
            // Elimina los caracteres no permitidos (ej. "-")
            texto = texto.replace(/[^a-zA-Z0-9]/g, "");  
            // Asigna el texto limpio a la variable vinculada con v-model
                this.placaVehiculoSecundario = texto; 
        },
        handleKeyDown(event) {
             // Expresión regular que identifica los caracteres especiales
            const regex = /^[a-zA-Z0-9]+$/; 
            // Verifica si el carácter presionado es un carácter especial
             if (!regex.test(event.key)) {
                // Si es un carácter especial, evita el evento keydown
                event.preventDefault();
            }
        },
        handleKeyDownSoloNumero(event) {
            const keyCode = event.keyCode || event.which;
               if (keyCode === 8 || keyCode === 46) {
                    return;
                }
          const regex = /^[0-9]*\.?[0-9]{0,2}$/; 
            // Verifica si el carácter presionado es un carácter especial
             if (!regex.test(event.target.value + event.key)) {
                // Si es un carácter especial, evita el evento keydown
                event.preventDefault();
            }
        },
        guionNumero(event){
         // Expresión regular que identifica los caracteres especiales
            const regex = /^[a-zA-Z0-9-]+$/; 
            // Verifica si el carácter presionado es un carácter especial
             if (!regex.test(event.key)) {
                // Si es un carácter especial, evita el evento keydown
                event.preventDefault();
            }
        },
        numeroPunto(event){
             const keyCode = event.keyCode || event.which;
               if (keyCode === 8 || keyCode === 46) {
                    return;
                }
        // Expresión regular que identifica los caracteres especiales
            const regex = /^[\d.]+$/; 
            // Verifica si el carácter presionado es un carácter especial
             if (!regex.test(event.key)) {
                // Si es un carácter especial, evita el evento keydown
                event.preventDefault();
            }
        },
        infoSunat(){
            this.cargando = true;
            let datos
            axios
            .post(process.env.VUE_APP_API_URL + 'usuario/credenciales/sunat',{
                token: this.$store.getters.userToken
            })
            .then(response=>(
            datos = response.data.response,
            this.validarInfo(response.data.response)
            ))
            .catch(error=>(
                console.log('ERROR SUNAT',error)
            ))
        },
        validarInfo(value){
            this.cargando = false
            if(value.username.length == 8 && 
                value.password.length >= 6 && 
                value.client_id !='' &&
                value.client_secret !=''){
                    this.ocultarGuiaTransportista = false;
            }else {
                this.ocultarGuiaTransportista = true
            }
        },
        irAOpcionesSunat(){
             this.$router.push("/panel").catch(err => {});  
        },
        listarTerceros(){
            axios
            .post(process.env.VUE_APP_API_URL + 'terceros/listar/1',{
                token: this.$store.getters.userToken
            })
            .then(response=>(
                this.listaTer = response.data
            ))
            .catch(error=>(
               console.log(error)
            ))
        },
        filtrarDocumento(){
            let idTercero
            this.listaTer.forEach(element => {
                if(this.remitente.numero == element.documento){
                   idTercero = element.idTercero
                }
            });
            if(idTercero !=''){
                this.tercerosDireccionesListar(idTercero)
            }
        },
        filtrarDocumentoLlegada(){
            let idTerceroReceptor
            this.listaTer.forEach(element => {
                if(this.receptor.numero == element.documento){
                    if(element.idTercero !=''){
                        idTerceroReceptor = element.idTercero
                        this.tercerosDireccionesLlegada(idTerceroReceptor)
                    }else{
                        console.log('')
                    }
                }else{
                    console.log('EL RUC NO ESTA REGISTRADO EN NEGOCIOS')
                }
            });
        },
        tercerosDireccionesListar(idTercero){
            axios
            .post(process.env.VUE_APP_API_URL + 'terceros/direcciones/listar',{
                token: this.$store.getters.userToken,
                id:idTercero
            })
            .then(response=>(
                this.capturaDirecciones = response.data.response.data,
                this.capturaDirecciones.forEach(element => {
                   this.listUbigeo.push(element)
                })
            ))
            .catch(error=>(
               console.log(error)
            ))
        },
        tercerosDireccionesLlegada(idTerceroReceptor){
                axios
                .post(process.env.VUE_APP_API_URL + 'terceros/direcciones/listar',{
                    token: this.$store.getters.userToken,
                    id:idTerceroReceptor
                })
                .then(response=>(
                    this.capturaDireccionesLlegada = response.data.response.data,
                    this.direccionLlegadaSelector = 0
                ))
                .catch(error=>(
                    console.log(error)
                ))
        },
        validarDireccionLlegada(){
            if(this.receptor.numero.length == 11){
                return false;
            }else
                return true;
        },
        initDates: function () {
            let r1 = {
                from: this.$moment().subtract(50000,"years"),
                to: this.$moment().subtract(2,"days")
            };
            let r2 = {
                from: this.$moment().add(0,"days"),
                to: this.$moment().add(60000,"years")
            };
            this.diasnopermitidos.ranges.splice(r1);
            this.diasnopermitidos.ranges.splice(r2);
            this.diasnopermitidos.ranges.push(r1);
            this.diasnopermitidos.ranges.push(r2);
            this.currentdate = this.$moment().format('YYYY-MM-DD HH:mm:ss')
        },
    }
}
</script>
<style scoped>
.multicolorFondo{
  border-radius: 5px;
  background: -webkit-linear-gradient(110deg, #fdcd3b 60%, #ffed4b 60%);
  background: -o-linear-gradient(110deg, #fdcd3b 60%, #ffed4b 60%);
  background: -moz-linear-gradient(110deg, #fdcd3b 60%, #ffed4b 60%);
  background: linear-gradient(110deg, #fdcd3b 60%, #ffed4b 60%);
}
.Subtitulos{
   background-color:white;
   width:100%; 
   border-radius:5px;
   padding-left: 10px;
    /* color: #00b3b3; */
}
.searcher-field{
        z-index: 1000;
        position: absolute;
        max-height: 200px !important;
        overflow-y: scroll;
        width: 620px;
    }
.searcher-fieldplaca{
        z-index: 1000;
        position: absolute;
        max-height: 200px !important;
        overflow-y: scroll;
        width: 850px;
    }
.searcher-fieldconductor{
        z-index: 1000;
        position: absolute;
        max-height: 200px !important;
        overflow-y: scroll;
        width: 720px;
    }
.searcher-result{
        font-size: smaller;
        padding: 2px 0px 2px 0px;
        cursor: pointer;
    }
.titulosPrimario{
        padding:0px;
        margin: 0px;
        color: #00b3b3;
    }
.titulosSecundarios{
        padding:0px;
        margin: 0px;
        color: red;
    }
.searcher-result2 {
        background-color: white;
        font-size: 1em;
        cursor: pointer;
    }
.searcher-result2 :hover{
        background-color: #DAF1F9;
        border:1px solid grey
    }
.tablaborde{
        border: 1px solid #B8cdd5;
    }
.searcher-result3{
        background-color: #77AEC1;
    }
.searcher-resultAsociados{
        background-color: #F1CE40;
    }
.centrarTitulo{
        text-align: center;
    }
.bordesYtexto{
        border: 1px solid;
        color:black
    }
.input-buscar::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: black;
  opacity: 1; /* Firefox */
    }

.input-buscar:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: black;
    }

.input-buscar::-ms-input-placeholder { /* Microsoft Edge */
  color: black;
    }
    /* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>